import "./risultati.74afa87f.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6be7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6be7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a7oaJ", function(module, exports) {

$parcel$export(module.exports, "loadPlannerDraft", () => $75dd4eed55130d28$export$afc61dac49205150);
$parcel$export(module.exports, "savePlannerDraft", () => $75dd4eed55130d28$export$1fcd7530e4b55e27);
$parcel$export(module.exports, "clearPlannerDraft", () => $75dd4eed55130d28$export$f895c61c7541ddef);
const $75dd4eed55130d28$var$FINANCIAL_PLANNER_DRAFT_KEY = 'financial_planner_draft_v1';
function $75dd4eed55130d28$export$afc61dac49205150() {
    try {
        const raw = localStorage.getItem($75dd4eed55130d28$var$FINANCIAL_PLANNER_DRAFT_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || !parsed.data) return null;
        return parsed;
    } catch (error) {
        return null;
    }
}
function $75dd4eed55130d28$export$1fcd7530e4b55e27(data, step, substepIndex) {
    try {
        localStorage.setItem($75dd4eed55130d28$var$FINANCIAL_PLANNER_DRAFT_KEY, JSON.stringify({
            data: data,
            step: step,
            substepIndex: substepIndex,
            updatedAt: Date.now()
        }));
    } catch (error) {
    // Storage pieno o disabilitato: il planner continua a funzionare senza bozza
    }
}
function $75dd4eed55130d28$export$f895c61c7541ddef() {
    try {
        localStorage.removeItem($75dd4eed55130d28$var$FINANCIAL_PLANNER_DRAFT_KEY);
    } catch (error) {
    // ignore
    }
}

});

// Wizard del Check-up finanziario (pagina /check-up-finanziario/wizard).
// Percorso a step/substep, validazione, bozza locale, import backup e recap.
// I calcoli vivono in financialPlannerEngine.js, i helper in financialPlannerShared.js.

var $a7oaJ = parcelRequire("a7oaJ");

var $bCl3L = parcelRequire("bCl3L");

var $ctPgg = parcelRequire("ctPgg");

var $bdDJG = parcelRequire("bdDJG");

var $6YR52 = parcelRequire("6YR52");
const $3e790f855f3f746b$var$TOTAL_STEPS = 8;
const $3e790f855f3f746b$var$STEP_NAMES = [
    'Situazione personale',
    'Entrate e spese',
    "Liquidit\xe0",
    'Fondo emergenza',
    'Debiti',
    'Spese previste',
    'Lungo termine',
    'Strategia finale'
];
// Substep config: defines substeps per step (0=intro, 'recap'=recap)
const $3e790f855f3f746b$var$SUBSTEP_CONFIG = {
    1: [
        'intro',
        'age',
        'work',
        'family',
        'housing',
        'recap'
    ],
    2: [
        'intro',
        'income',
        'essential',
        'discretionary',
        'recap'
    ],
    3: [
        'intro',
        'accounts',
        'fee',
        'recap'
    ],
    4: [
        'intro',
        'deposit',
        'emergency_status',
        'recap'
    ],
    5: [
        'intro',
        'debt_status',
        'mortgage',
        'personal',
        'revolving_car',
        'recap'
    ],
    6: [
        'intro',
        'goals_list',
        'money_market',
        'recap'
    ],
    7: [
        'intro',
        'status_pension',
        'breakdown',
        'risk',
        'recap'
    ],
    8: [
        'intro'
    ]
};
const $3e790f855f3f746b$var$SUBSTEP_LABELS = {
    1: {
        intro: 'Benvenuto',
        age: "Et\xe0",
        work: 'Lavoro',
        family: 'Famiglia',
        housing: 'Abitazione',
        recap: 'Riepilogo'
    },
    2: {
        intro: 'Benvenuto',
        income: 'Reddito',
        essential: 'Spese necessarie',
        discretionary: 'Spese discrezionali',
        recap: 'Riepilogo'
    },
    3: {
        intro: 'Benvenuto',
        accounts: 'Conti correnti',
        fee: 'Costi',
        recap: 'Riepilogo'
    },
    4: {
        intro: 'Benvenuto',
        deposit: 'Conto deposito',
        emergency_status: 'Fondo emergenza',
        recap: 'Riepilogo'
    },
    5: {
        intro: 'Benvenuto',
        debt_status: 'Debiti',
        mortgage: 'Mutuo',
        personal: 'Prestito personale',
        revolving_car: 'Revolving e auto',
        recap: 'Riepilogo'
    },
    6: {
        intro: 'Benvenuto',
        goals_list: 'Spese previste',
        money_market: 'Capitale prudente',
        recap: 'Riepilogo'
    },
    7: {
        intro: 'Benvenuto',
        status_pension: 'Investimenti e pensione',
        breakdown: 'Dettaglio',
        risk: 'Rischio e abitudini',
        recap: 'Riepilogo'
    },
    8: {
        intro: 'Conferma'
    }
};
const $3e790f855f3f746b$var$SUBSTEP_ICONS = {
    intro: 'sparkle',
    age: 'user-circle',
    work: 'briefcase',
    family: 'users-three',
    housing: 'house-line',
    income: 'wallet',
    essential: 'house',
    discretionary: 'coffee',
    accounts: 'bank',
    fee: 'coins',
    emergency_status: 'lifebuoy',
    deposit: 'piggy-bank',
    location: 'shield-check',
    status_pension: 'chart-line-up',
    breakdown: 'chart-pie-slice',
    mortgage: 'house-simple',
    personal: 'hand-coins',
    revolving_car: 'warning-circle',
    debt_status: 'scales',
    risk: 'clock-countdown',
    goals_list: 'flag-banner',
    money_market: 'coin-vertical',
    recap: 'check-circle'
};
const $3e790f855f3f746b$var$SUBSTEP_COPY = {
    age: {
        prompt: 'Quanti anni hai?',
        why: "L\u2019et\xe0 influenza orizzonte temporale, velocit\xe0 di recupero dagli errori e peso che sicurezza e crescita devono avere nel piano."
    },
    work: {
        prompt: "Quanto \xe8 stabile oggi la tua entrata principale?",
        why: "Un reddito pi\xf9 fragile richiede pi\xf9 cuscinetto prima di pensare a investimenti o obiettivi di lungo periodo."
    },
    family: {
        prompt: 'Chi conta sul tuo reddito, oltre a te?',
        why: 'Famiglia e persone a carico cambiano la dimensione minima del fondo emergenza e la tolleranza agli imprevisti.'
    },
    housing: {
        prompt: 'Come abiti: affitto, mutuo o casa tua?',
        why: "Affitto, mutuo o casa gi\xe0 pagata incidono direttamente sulla pressione mensile e sul margine di manovra."
    },
    income: {
        prompt: 'Quanto entra sul conto in un mese normale?',
        why: 'Il piano parte dal cash flow reale: senza una base credibile su entrate e uscite, ogni consiglio sarebbe distorto.'
    },
    essential: {
        prompt: 'Quanto spendi al mese per le cose a cui non puoi rinunciare?',
        why: 'Le spese sono la base di tutti i calcoli del piano: distinguere le necessarie dalle discrezionali ti dice quanto margine di manovra hai in un mese difficile.'
    },
    discretionary: {
        prompt: 'E quanto spendi per tutto il resto: svago, ristoranti, viaggi, shopping?',
        why: 'Le spese discrezionali sono il tuo margine di manovra: sapere quanto pesano ti dice quanto respiro puoi recuperare in fretta senza toccare le basi.'
    },
    accounts: {
        prompt: 'Quanto tieni oggi sui conti correnti?',
        why: "Sui conti serve la liquidit\xe0 per il mese e i piccoli imprevisti. Il resto sta bene l\xec solo se il conto rende e quei soldi hanno un compito, come le emergenze o le spese vicine: fermi a tasso zero, perdono valore."
    },
    fee: {
        prompt: 'Quanto paghi di canoni bancari in un anno?',
        why: "Conti e carte: ogni canone ricorrente \xe8 rendimento perso certo, e ridurli \xe8 l'ottimizzazione pi\xf9 semplice che esista."
    },
    emergency_status: {
        prompt: "Quanto dei tuoi soldi \xe8 il paracadute per gli imprevisti?",
        why: "Ora che sappiamo dove stanno i tuoi soldi, decidiamo insieme quanto \xe8 il fondo emergenza: \xe8 la base del piano, e se non sai da dove partire te lo proponiamo noi."
    },
    deposit: {
        prompt: 'Hai conti deposito o riserve separate?',
        why: "Distinguere la liquidit\xe0 del mese dalla riserva di sicurezza evita di confondere soldi \u201Cdisponibili\u201D con soldi \u201Cintoccabili\u201D."
    },
    status_pension: {
        prompt: 'Hai investimenti o un fondo pensione?',
        why: "Serve a capire se stai mettendo crescita prima della sicurezza o se l\u2019ordine delle priorit\xe0 \xe8 gi\xe0 sensato."
    },
    breakdown: {
        prompt: 'Quanto hai in ciascun tipo di strumento?',
        why: "La composizione conta pi\xf9 del totale: due patrimoni uguali possono avere livelli di rischio completamente diversi."
    },
    mortgage: {
        prompt: 'Hai un mutuo in corso?',
        why: "Il mutuo \xe8 spesso il debito pi\xf9 grande ma non sempre il pi\xf9 urgente: servono importo e tasso per capirlo."
    },
    personal: {
        prompt: 'Hai prestiti personali in corso?',
        why: 'I debiti a tassi medi o alti possono battere qualsiasi rendimento di investimento e vanno letti prima.'
    },
    revolving_car: {
        prompt: 'Hai carte revolving o un finanziamento auto?',
        why: "Questi prodotti spesso hanno il costo pi\xf9 alto e possono diventare il vero collo di bottiglia del piano."
    },
    debt_status: {
        prompt: 'Hai debiti in corso?',
        why: "Se ci sono debiti costosi vengono prima di tutto: estinguerli \xe8 il rendimento garantito pi\xf9 alto che esista."
    },
    risk: {
        prompt: 'Come ti comporti quando i mercati scendono?',
        why: 'Reazione ai ribassi e frequenza di controllo definiscono il rischio che puoi permetterti davvero, non quello sulla carta.'
    },
    goals_list: {
        prompt: 'Quali spese importanti hai davanti nei prossimi 10 anni?',
        why: 'Separare gli obiettivi a 1, 3 o 10 anni evita di investire soldi che ti serviranno troppo presto.'
    },
    money_market: {
        prompt: "Hai riserve gi\xe0 parcheggiate in titoli di Stato, buoni postali od ETF monetari?",
        why: "BOT, BTP, buoni fruttiferi ed ETF monetari sono capitale prudente, non investimento: sapere quanto ne hai ci dice quante riserve coprono gi\xe0 le tue spese previste."
    },
    recap: {
        prompt: 'Controlla i dati di questo passaggio.',
        why: 'Un controllo rapido riduce errori e ti permette di correggere subito i dati che cambiano davvero il piano.'
    },
    intro: {
        prompt: 'Ultimo controllo prima dei risultati.',
        why: "Qui smettiamo di raccogliere dati e passiamo alla sintesi: priorit\xe0, warning e prossimi passi concreti."
    }
};
// Mappa step wizard -> pilastro del metodo (1 liquidità, 2 emergenza, 3 spese previste, 4 lungo termine)
const $3e790f855f3f746b$var$STEP_PILLARS = {
    3: {
        pillar: 1,
        label: "Liquidit\xe0"
    },
    4: {
        pillar: 2,
        label: 'Fondo emergenza'
    },
    6: {
        pillar: 3,
        label: 'Spese previste'
    },
    7: {
        pillar: 4,
        label: 'Lungo termine'
    }
};
// "La teoria in breve": micro-lezioni per schermata, tratte dal corso
const $3e790f855f3f746b$var$SUBSTEP_THEORY = {
    age: {
        title: "Il tempo \xe8 la risorsa pi\xf9 importante",
        paragraphs: [
            "In finanza personale l'et\xe0 conta perch\xe9 definisce il tuo orizzonte temporale. Pi\xf9 tempo hai davanti, pi\xf9 il tuo denaro pu\xf2 crescere e pi\xf9 errori puoi permetterti di assorbire senza conseguenze permanenti.",
            "Vicino alla pensione la logica si inverte: la priorit\xe0 diventa proteggere quello che hai costruito, non cercare rendimento. La stessa scelta pu\xf2 essere giusta a 25 anni e sbagliata a 60."
        ]
    },
    work: {
        title: 'Reddito stabile e reddito fragile richiedono piani diversi',
        paragraphs: [
            "Un dipendente a tempo indeterminato ha un'entrata prevedibile e pu\xf2 permettersi un cuscinetto pi\xf9 piccolo. Chi ha un contratto a termine o lavora in proprio deve mettere in conto mesi con entrate ridotte, e il suo fondo emergenza va dimensionato pi\xf9 largo.",
            `Non \xe8 un pregiudizio, sono i numeri: secondo ${(0, $bdDJG.cite)('istat', 'Istat')}, il rischio di povert\xe0 \xe8 del 17% tra i lavoratori autonomi e del 16,2% tra i dipendenti a termine, contro l'8,5% di chi ha un contratto a tempo indeterminato. Circa il doppio, pur lavorando.`,
            "La stabilit\xe0 incide anche sugli investimenti di lungo termine: chi ha un futuro economico incerto consolida prima le basi, perch\xe9 rischia di aver bisogno dei soldi proprio nel momento sbagliato."
        ]
    },
    family: {
        title: 'Quante entrate reggono il nucleo, e chi dipende da te',
        paragraphs: [
            "La variabile che pesa di pi\xf9 non \xe8 quante persone siete, ma quante entrate avete. Se i redditi sono due e uno si ferma, l'altro continua a pagare affitto e bollette: c'\xe8 una rete. Se il reddito \xe8 uno solo, quella rete non c'\xe8, e serve un cuscinetto pi\xf9 grande anche a parit\xe0 di persone. Una coppia in cui lavorano entrambi \xe8 pi\xf9 protetta di un single; una coppia che si regge su uno stipendio solo lo \xe8 molto meno.",
            "Chi ha figli o persone a carico non protegge solo se stesso: un imprevisto colpisce tutti. All'estremo opposto, chi vive con i genitori ha spese fisse minime e una rete gi\xe0 pronta, e pu\xf2 concentrarsi sull'accumulo invece che sulla protezione."
        ]
    },
    housing: {
        title: "La casa \xe8 la spesa fissa che decide tutto il resto",
        paragraphs: [
            'Affitto e mutuo sono quasi sempre la voce pi\xf9 pesante del budget. Un mutuo a tasso basso \xe8 considerato un "debito buono": finanzia un bene reale e non va estinto con urgenza. L\'affitto d\xe0 meno sicurezza sul lungo periodo, ma in cambio offre flessibilit\xe0: se serve, puoi ridurre la spesa o cambiare casa pi\xf9 facilmente di chi ha un mutuo.',
            "Chi ha una casa di propriet\xe0 senza mutuo parte con la massima sicurezza abitativa: le sue spese necessarie sono strutturalmente pi\xf9 basse e il piano pu\xf2 permettersi obiettivi pi\xf9 ambiziosi."
        ]
    },
    income: {
        title: 'Il piano parte dal cash flow, non dal patrimonio',
        paragraphs: [
            "Il cash flow \xe8 la differenza tra quello che entra e quello che esce ogni mese. \xc8 la leva pi\xf9 importante di tutto il piano: determina quanto velocemente puoi costruire sicurezza e raggiungere obiettivi.",
            "Per conoscere il numero vero, non quello percepito, guarda gli estratti conto degli ultimi 3 mesi: somma le entrate, somma le uscite, dividi per tre. Quasi tutti scoprono di spendere pi\xf9 di quanto pensavano."
        ]
    },
    essential: {
        title: "Le spese necessarie sono l'unit\xe0 di misura della sicurezza",
        paragraphs: [
            'Le spese necessarie sono quelle che pagheresti comunque anche in un mese difficile: casa, utenze, cibo, trasporti, rate e assicurazioni. Le discrezionali sono quelle che puoi ridurre in fretta se serve.',
            'Il totale delle spese \xe8 il numero su cui si dimensiona il fondo emergenza, in "mesi di spese coperti". La distinzione tra necessarie e discrezionali ti dice invece quanto puoi recuperare in fretta tagliando: conoscere questi numeri con precisione vale pi\xf9 di qualsiasi consiglio di investimento.'
        ],
        pills: [
            {
                label: 'Il fondo di emergenza',
                href: '/pills/fondo-di-emergenza'
            }
        ]
    },
    discretionary: {
        title: 'Le discrezionali sono il tuo ammortizzatore',
        paragraphs: [
            "Ristoranti, viaggi, svago, shopping: sono le spese che rendono la vita piacevole, e va benissimo cos\xec. Ma sono anche il primo posto dove recuperare margine se il piano si inceppa.",
            "Una regola pratica: se le spese discrezionali superano il 30% del reddito, c'\xe8 spazio per accelerare parecchio senza toccare la qualit\xe0 delle basi. Ridurle del 20% per qualche mese \xe8 il modo pi\xf9 rapido per costruire il fondo emergenza."
        ]
    },
    accounts: {
        title: "Pilastro 1: la liquidit\xe0 per il mese",
        paragraphs: [
            "Il primo pilastro della finanza personale \xe8 la liquidit\xe0 per la vita quotidiana: sul conto corrente dovrebbero esserci 1-2 mesi di spese, abbastanza per gestire il mese e i piccoli imprevisti.",
            "Tenerne di meno significa vivere con l'ansia dell'addebito inatteso. Tenerne di pi\xf9 va bene solo a una condizione: che il conto renda qualcosa e che quei soldi abbiano un compito preciso, come il fondo emergenza o una spesa vicina.",
            "La liquidit\xe0 in pi\xf9 su un conto a tasso zero, invece, non ha n\xe9 compito n\xe9 difesa: l'inflazione la erode ogni anno."
        ],
        pills: [
            {
                label: 'Quanti soldi tenere sul conto',
                href: '/pills/quanti-soldi-tenere-sul-conto-corrente'
            }
        ]
    },
    fee: {
        title: "Il canone \xe8 un rendimento negativo garantito",
        paragraphs: [
            'Ogni euro di costo bancario \xe8 un euro perso con certezza, ogni anno. Per compensare un canone da 100 euro all\'anno servirebbero 2.000 euro investiti al 5%: ecco perch\xe9 tagliare i costi \xe8 il "rendimento" pi\xf9 facile da ottenere.',
            "Esistono conti correnti a canone zero o azzerabile con l'accredito dello stipendio. Se paghi pi\xf9 di 100 euro all'anno, il cambio di conto \xe8 quasi sempre la prima azione del piano."
        ]
    },
    emergency_status: {
        title: 'Pilastro 2: prima il paracadute, poi tutto il resto',
        paragraphs: [
            'Il fondo emergenza non \xe8 "risparmio generico": \xe8 una somma dedicata, separata dal resto, che esiste solo per gli imprevisti gravi. E la regola d\'oro \xe8 che viene prima degli investimenti: senza paracadute, il primo imprevisto ti costringe a vendere nel momento peggiore o a indebitarti.',
            `Quanto serve non \xe8 una legge fisica. Il "tre-sei mesi di spese" che si sente ripetere \xe8 una regola pratica, che gli stessi enti che la citano ammettono essere tale. La soglia con pi\xf9 sostegno \xe8 tre mesi: \xe8 quella con cui l'${(0, $bdDJG.cite)('ocse', 'OCSE')} misura la resilienza finanziaria delle famiglie, e nella media dei paesi OCSE solo il 43% degli adulti dichiara di poter coprire tre mesi di spese se perdesse l'entrata principale.`,
            "Noi ti suggeriamo un numero in base ai tuoi fattori di rischio, ma la scelta \xe8 tua: tra 3 e 9 mesi va bene, fino a 12 \xe8 accettabile; oltre, \xe8 pi\xf9 sicurezza di quanta te ne serva, e a quei soldi conviene dare un compito diverso.",
            `La cosa pi\xf9 importante, per\xf2, \xe8 il primo gradino. Una ricerca ${(0, $bdDJG.cite)('vanguard', 'Vanguard')} su 12.400 investitori ha misurato che mettere da parte i primi 2.000 dollari si associa a un salto di benessere finanziario pi\xf9 grande di quello che si guadagna arrivando poi al fondo pieno da tre-sei mesi. In Italia la soglia che conta \xe8 quella della "spesa imprevista" da circa mille euro: secondo ${(0, $bdDJG.cite)('eurostat', 'Eurostat')}, un italiano su quattro (25,6% nel 2025) non riuscirebbe a coprirla.`
        ],
        pills: [
            {
                label: 'Il fondo di emergenza',
                href: '/pills/fondo-di-emergenza'
            }
        ]
    },
    deposit: {
        title: 'La riserva separata: dove parcheggiare la sicurezza',
        paragraphs: [
            "Un conto deposito libero o svincolabile \xe8 una buona casa per il fondo emergenza: rende qualcosa, \xe8 garantito dal Fondo Interbancario fino a 100.000 euro per banca e depositante, e resta accessibile.",
            'Quello vincolato invece no: in emergenza non puoi aspettare la scadenza del vincolo. Va bene solo per spese con data certa, non per gli imprevisti.'
        ],
        pills: [
            {
                label: 'Il conto deposito',
                href: '/pills/conto-deposito-come-funziona'
            }
        ]
    },
    status_pension: {
        title: 'Pilastro 4: il lungo termine si guadagna',
        paragraphs: [
            "Gli investimenti azionari sono il quarto e ultimo pilastro: si costruiscono solo dopo liquidit\xe0, fondo emergenza e copertura delle spese previste. Se l'ordine si inverte, il rischio smette di essere sotto controllo.",
            "Il fondo pensione \xe8 un caso a parte: i versamenti sono deducibili fino a 5.164 euro all'anno e la tassazione in uscita \xe8 agevolata. Conviene soprattutto con aliquota IRPEF alta e se il datore di lavoro contribuisce; conviene meno se i costi di gestione superano l'1%.",
            "Le polizze vita di risparmio (gestioni separate, unit-linked) contano nel patrimonio e vanno censite: sono soldi tuoi, spesso tanti. La variabile che le decide non \xe8 il mercato ma i costi del contratto, che stanno nel rendiconto annuale e nel KID."
        ],
        pills: [
            {
                label: 'Investire a lungo termine',
                href: '/pills/investire-a-lungo-termine'
            },
            {
                label: 'La pensione integrativa',
                href: '/pills/pensione-integrativa-guida'
            }
        ]
    },
    breakdown: {
        title: "La composizione conta pi\xf9 del totale",
        paragraphs: [
            'Due portafogli da 20.000 euro possono avere rischi completamente diversi. Un ETF su un indice mondiale distribuisce il rischio su oltre mille aziende; poche azioni singole concentrano tutto su pochi nomi; le criptovalute sono speculazione, con oscillazioni del 50-80%.',
            'Attenzione anche ai fondi comuni: costi di gestione spesso sopra il 2% all\'anno, contro lo 0,2% di un ETF equivalente. Nel lungo periodo questa differenza si mangia una fetta enorme del rendimento.'
        ],
        pills: [
            {
                label: 'Investire a lungo termine',
                href: '/pills/investire-a-lungo-termine'
            }
        ]
    },
    mortgage: {
        title: 'Il mutuo \xe8 spesso un debito "buono"',
        paragraphs: [
            "Un mutuo con tasso sotto il 4-5% finanzia un bene reale a un costo ragionevole: non \xe8 il nemico del piano e raramente va estinto in anticipo con urgenza.",
            "La regola generale: estinguere un debito equivale a un investimento garantito con rendimento pari al suo tasso. Con un mutuo al 3%, spesso ci sono usi migliori per il tuo margine; con un debito al 15%, non c'\xe8 investimento che tenga."
        ],
        pills: [
            {
                label: 'Debiti buoni e debiti cattivi',
                href: '/pills/debiti-buoni-e-cattivi'
            }
        ]
    },
    personal: {
        title: 'I prestiti personali drenano il margine',
        paragraphs: [
            "I prestiti personali hanno spesso TAEG tra il 6% e il 10%: estinguerli in anticipo \xe8 come ottenere quel rendimento garantito e senza rischio, un risultato che nessun investimento prudente pu\xf2 promettere.",
            "Guarda sempre il TAEG e non il TAN: include tutti i costi ed \xe8 l'unico numero con cui confrontare due finanziamenti."
        ],
        pills: [
            {
                label: 'Debiti buoni e debiti cattivi',
                href: '/pills/debiti-buoni-e-cattivi'
            }
        ]
    },
    revolving_car: {
        title: 'Le revolving sono l\'emergenza numero uno',
        paragraphs: [
            "Le carte revolving hanno spesso TAEG del 15-20%: sono il debito pi\xf9 costoso in circolazione e vengono prima di qualsiasi altra cosa nel piano, incluso il fondo emergenza.",
            'Attenzione a non confonderle con la carta di credito "a saldo", quella che si azzera ogni mese: quella non matura interessi e non \xe8 un debito da inserire qui. Il problema \xe8 la revolving, che rateizza il rimborso con interessi a due cifre.',
            'Ogni 1.000 euro di revolving estinti al 18% ti fanno "guadagnare" 180 euro all\'anno, garantiti. Nessun investimento legale offre un rendimento simile senza rischio.'
        ],
        pills: [
            {
                label: 'Debiti buoni e debiti cattivi',
                href: '/pills/debiti-buoni-e-cattivi'
            }
        ]
    },
    risk: {
        title: 'Il comportamento batte la strategia',
        paragraphs: [
            "Guardare i prezzi ogni giorno genera ansia, e l'ansia genera l'errore pi\xf9 costoso della finanza personale: vendere durante un ribasso, trasformando una oscillazione temporanea in una perdita definitiva.",
            "Chi investe a lungo termine ha bisogno di controllare il portafoglio poche volte all'anno. Se senti il bisogno di guardarlo ogni giorno, \xe8 un segnale che il rischio che hai preso \xe8 troppo per te."
        ],
        pills: [
            {
                label: 'Il comportamento batte la strategia',
                href: '/pills/finanza-comportamentale-errori'
            }
        ]
    },
    goals_list: {
        title: 'Le spese previste vanno finanziate, non investite',
        paragraphs: [
            'Auto da cambiare, ristrutturazione, matrimonio, master: ogni spesa che sai di dover affrontare va abbinata a uno strumento sicuro con scadenza coerente, per esempio un BTP che scade poco prima della data della spesa.',
            "Cos\xec i soldi del terzo pilastro restano separati dal lungo termine: non rischi di doverli disinvestire in perdita e non li confondi con il capitale che pu\xf2 restare investito per decenni."
        ],
        pills: [
            {
                label: 'I soldi per le spese future',
                href: '/pills/soldi-per-spese-future'
            }
        ]
    },
    money_market: {
        title: 'Il capitale prudente: BOT, BTP, buoni postali ed ETF monetari',
        paragraphs: [
            "BOT e BTP sono prestiti allo Stato con una scadenza nota: se li tieni fino alla fine, sai gi\xe0 quanto incasserai. Per una spesa prevista si sceglie un titolo che scade poco prima della data della spesa.",
            "I buoni fruttiferi postali sono la versione senza scadenza obbligata: garantiti dallo Stato, rimborsabili in ogni momento recuperando almeno il capitale versato. Il rendimento per\xf2 cresce a gradini con gli anni e cambia da serie a serie: quelle recenti spesso rendono meno di un deposito o di un BTP di pari durata.",
            "L'ETF monetario (il pi\xf9 noto \xe8 XEON) \xe8 l'eccezione tra gli ETF: segue i tassi a breve dell'area euro, il prezzo non oscilla come le azioni ed \xe8 un parcheggio remunerato che vive sul conto titoli. Tutti gli altri ETF sono capitale di lungo termine, questo \xe8 capitale prudente.",
            "Occhio alla fiscalit\xe0: i depositi pagano il 26% sui guadagni, BOT, BTP e buoni postali il 12,5%. Gli ETF monetari stanno in mezzo: aliquota standard 26%, ma la quota investita in titoli di Stato \xe8 tassata al 12,5%, e per i fondi a paniere governativo l'aliquota effettiva si ferma spesso intorno al 13-14%."
        ],
        pills: [
            {
                label: 'BOT e BTP',
                href: '/pills/bot-e-btp'
            },
            {
                label: 'Gli ETF monetari',
                href: '/pills/etf-monetari'
            }
        ]
    }
};
// Registro dei campi del wizard: la fonte unica per lettura (readWizardData),
// obbligatorietà (validateStep/validateSubstep) e riepiloghi (renderStepRecap).
// Un campo nuovo si aggiunge QUI e nell'HTML; per convenzione id dell'input =
// chiave nel payload dati.
// - required: messaggio mostrato se manca (vale come obbligo a livello substep;
//   stepRequired: false lo esclude dal controllo di step, quirk storico di
//   carta e broker). Gli obblighi condizionali vivono in SUBSTEP_RULES.
// - options: mappa valore -> etichetta usata nei riepiloghi.
// - recap: etichetta nel riepilogo; euro: true formatta il valore come importo.
//   Le righe calcolate (totali, condizionali) restano definite in renderStepRecap.
// - manual: true = letto con logica dedicata dentro readWizardData.
const $3e790f855f3f746b$var$FIELDS = [
    {
        id: 'age',
        step: 1,
        substep: 'age',
        required: "Inserisci la tua et\xe0 prima di continuare.",
        recap: "Et\xe0"
    },
    {
        id: 'workStatus',
        step: 1,
        substep: 'work',
        required: 'Seleziona la tua situazione lavorativa.',
        recap: 'Situazione lavorativa',
        options: {
            employee_permanent: 'Dipendente a tempo indeterminato',
            employee_fixed: 'Dipendente a tempo determinato',
            freelancer: 'Libero professionista',
            student: 'Studente',
            retired: 'Pensionato',
            unemployed: 'Disoccupato'
        }
    },
    {
        id: 'familyStatus',
        step: 1,
        substep: 'family',
        required: 'Seleziona la tua situazione familiare.',
        recap: 'Situazione familiare',
        options: {
            single: 'Single',
            couple: 'Convivente/sposato senza figli',
            with_children: 'Con figli',
            separated: 'Separato/divorziato',
            parents: 'Con i genitori'
        }
    },
    {
        id: 'dependents',
        step: 1,
        substep: 'family',
        required: 'Indica quante persone hai a carico.',
        recap: 'Persone a carico'
    },
    {
        id: 'householdEarners',
        step: 1,
        substep: 'family'
    },
    // Censimento TCM: si chiede solo con persone a carico (visibilita' in syncConditionalFields)
    {
        id: 'hasTcm',
        step: 1,
        substep: 'family',
        recap: 'Polizza TCM',
        options: {
            no: 'No',
            yes: "S\xec",
            unknown: 'Non lo so'
        }
    },
    {
        id: 'housingStatus',
        step: 1,
        substep: 'housing',
        required: 'Seleziona come abiti oggi.',
        recap: 'Come abiti',
        options: {
            owner_mortgage: "Propriet\xe0 con mutuo",
            owner_free: "Propriet\xe0 senza mutuo",
            rent: 'In affitto',
            parents_house: 'Casa dei genitori'
        }
    },
    {
        id: 'monthlyIncome',
        step: 2,
        substep: 'income',
        required: 'Inserisci il reddito mensile netto.',
        recap: 'Reddito mensile netto',
        euro: true
    },
    {
        id: 'expenseEssential',
        step: 2,
        substep: 'essential',
        required: 'Inserisci le spese necessarie mensili (o stimale con l\'aiuto delle categorie).',
        recap: 'Spese necessarie',
        euro: true
    },
    // Le categorie degli aiuti di stima si salvano per restare modificabili al ritorno
    {
        id: 'estimateHousing',
        step: 2,
        substep: 'essential'
    },
    {
        id: 'estimateBills',
        step: 2,
        substep: 'essential'
    },
    {
        id: 'estimateGroceries',
        step: 2,
        substep: 'essential'
    },
    {
        id: 'estimateTransport',
        step: 2,
        substep: 'essential'
    },
    {
        id: 'estimateOther',
        step: 2,
        substep: 'essential'
    },
    {
        id: 'expenseDiscretionary',
        step: 2,
        substep: 'discretionary',
        recap: 'Spese discrezionali',
        euro: true
    },
    {
        id: 'estimateDining',
        step: 2,
        substep: 'discretionary'
    },
    {
        id: 'estimateTravel',
        step: 2,
        substep: 'discretionary'
    },
    {
        id: 'estimateLeisure',
        step: 2,
        substep: 'discretionary'
    },
    {
        id: 'estimateSport',
        step: 2,
        substep: 'discretionary'
    },
    {
        id: 'estimateShopping',
        step: 2,
        substep: 'discretionary'
    },
    {
        id: 'accountFee',
        step: 3,
        substep: 'fee',
        required: 'Inserisci i costi annui dei conti correnti.',
        recap: 'Costi annui conti',
        euro: true
    },
    {
        id: 'creditCardFee',
        step: 3,
        substep: 'fee',
        recap: 'Canoni carte',
        euro: true
    },
    {
        id: 'emergencyClaim',
        step: 4,
        substep: 'emergency_status',
        manual: true,
        required: "Indica se hai gi\xe0 dei soldi da parte per gli imprevisti."
    },
    {
        id: 'emergencyStatus',
        step: 4,
        substep: 'emergency_status',
        manual: true,
        recap: 'Fondo emergenza',
        options: {
            none: 'Non ancora',
            partial: 'Parziale',
            complete: 'Completo'
        }
    },
    {
        id: 'emergencyAmount',
        step: 4,
        substep: 'emergency_status',
        manual: true
    },
    {
        id: 'emergencyLocation',
        step: 4,
        substep: 'emergency_status',
        manual: true,
        recap: 'Posizione fondo',
        options: {
            checking: 'Conto corrente',
            deposit_free: 'Conto deposito libero',
            deposit_withdrawable: 'Conto deposito svincolabile',
            deposit_bound: 'Conto deposito vincolato',
            split: "In pi\xf9 posti",
            other: 'Altro'
        }
    },
    {
        id: 'emergencyAccount',
        step: 4,
        substep: 'emergency_status',
        manual: true
    },
    {
        id: 'emergencyMonths',
        step: 4,
        substep: 'emergency_status'
    },
    {
        id: 'liquidityTargetMonths',
        step: 3,
        substep: 'accounts'
    },
    {
        id: 'investmentsStatus',
        step: 7,
        substep: 'status_pension',
        required: 'Indica se hai investimenti.',
        recap: 'Investimenti',
        options: {
            none: 'No',
            some: 'Qualche investimento',
            diversified: 'Portafoglio diversificato'
        }
    },
    {
        id: 'pensionFund',
        step: 7,
        substep: 'status_pension',
        required: 'Indica se hai un fondo pensione.',
        recap: 'Fondo pensione',
        options: {
            none: 'No',
            open: 'Fondo aperto',
            closed: 'Fondo chiuso',
            tfr: 'TFR/fondo aziendale',
            pip: 'PIP individuale'
        }
    },
    {
        id: 'lifeInsurance',
        step: 7,
        substep: 'status_pension',
        required: 'Indica se hai una polizza vita di risparmio.',
        stepRequired: false,
        recap: 'Polizza di risparmio',
        options: {
            none: 'No',
            guaranteed: "S\xec, a capitale garantito",
            unit_linked: "S\xec, unit-linked",
            unknown: "S\xec, tipo da verificare"
        }
    },
    {
        id: 'lifeInsuranceValue',
        step: 7,
        substep: 'status_pension'
    },
    {
        id: 'ral',
        step: 7,
        substep: 'status_pension',
        recap: 'Reddito complessivo annuo lordo',
        euro: true
    },
    {
        id: 'hasBrokerAccount',
        step: 7,
        substep: 'status_pension',
        required: 'Indica se hai un conto titoli o broker.',
        stepRequired: false,
        recap: 'Conto broker',
        options: {
            yes: "S\xec",
            no: 'No'
        }
    },
    {
        id: 'brokerFee',
        step: 7,
        substep: 'status_pension'
    },
    {
        id: 'investStocks',
        step: 7,
        substep: 'breakdown',
        manual: true
    },
    {
        id: 'investEtf',
        step: 7,
        substep: 'breakdown',
        manual: true
    },
    // Capitale prudente: BOT/BTP/obbligazioni, ETF monetari e buoni postali sono
    // censiti nel terzo pilastro (spese previste), non nel dettaglio investimenti
    {
        id: 'investBonds',
        step: 6,
        substep: 'money_market'
    },
    {
        id: 'investMoneyMarket',
        step: 6,
        substep: 'money_market'
    },
    {
        id: 'investPostalBonds',
        step: 6,
        substep: 'money_market'
    },
    {
        id: 'investFunds',
        step: 7,
        substep: 'breakdown',
        manual: true
    },
    {
        id: 'investCrypto',
        step: 7,
        substep: 'breakdown',
        manual: true
    },
    {
        id: 'investCash',
        step: 7,
        substep: 'breakdown',
        manual: true
    },
    {
        id: 'investCashRate',
        step: 7,
        substep: 'breakdown',
        manual: true
    },
    {
        id: 'hasDebts',
        step: 5,
        substep: 'debt_status',
        required: 'Indica se hai debiti in corso.',
        recap: 'Debiti',
        options: {
            none: 'Nessuno',
            yes: "S\xec"
        }
    },
    {
        id: 'debtMortgageAmount',
        step: 5,
        substep: 'mortgage'
    },
    {
        id: 'debtMortgageRate',
        step: 5,
        substep: 'mortgage'
    },
    {
        id: 'debtPersonalAmount',
        step: 5,
        substep: 'personal'
    },
    {
        id: 'debtPersonalRate',
        step: 5,
        substep: 'personal'
    },
    {
        id: 'debtRevolvingAmount',
        step: 5,
        substep: 'revolving_car'
    },
    {
        id: 'debtRevolvingRate',
        step: 5,
        substep: 'revolving_car'
    },
    {
        id: 'debtCarAmount',
        step: 5,
        substep: 'revolving_car'
    },
    {
        id: 'debtCarRate',
        step: 5,
        substep: 'revolving_car'
    },
    {
        id: 'reactionDrop',
        step: 7,
        substep: 'risk',
        required: 'Indica come reagiresti a un -20%.',
        recap: 'Reazione a -20%',
        options: {
            sell: 'Venderei tutto',
            hold: 'Terrei con ansia',
            buy: "Comprerei di pi\xf9",
            ignore: 'Non guarderei'
        }
    },
    {
        id: 'checkFrequency',
        step: 7,
        substep: 'risk',
        required: 'Indica quanto spesso controlli gli investimenti.',
        recap: 'Frequenza controllo',
        options: {
            never: 'Mai',
            yearly: 'Una volta all\'anno',
            monthly: 'Una volta al mese',
            weekly: 'Una volta a settimana',
            daily: 'Ogni giorno'
        }
    }
];
const $3e790f855f3f746b$var$FIELD_BY_ID = Object.fromEntries($3e790f855f3f746b$var$FIELDS.map((field)=>[
        field.id,
        field
    ]));
// Substep saltati in base alle risposte precedenti: dichiarativo, con un
// accessor sul valore corrente del campo (dal DOM, la fonte di verità del form)
const $3e790f855f3f746b$var$SUBSTEP_SKIP_RULES = {
    '5:mortgage': (value)=>value('hasDebts') === 'none',
    '5:personal': (value)=>value('hasDebts') === 'none',
    '5:revolving_car': (value)=>value('hasDebts') === 'none',
    '7:breakdown': (value)=>value('investmentsStatus') === 'none'
};
function $3e790f855f3f746b$var$readWizardData(goalRowsContainer) {
    const accountRowsContainer = document.getElementById('accountRows');
    const depositRowsContainer = document.getElementById('depositRows');
    const deposits = depositRowsContainer ? Array.from(depositRowsContainer.querySelectorAll('.planner-deposit-row')).map((row)=>({
            label: row.querySelector('[data-deposit-field="label"]')?.value || '',
            balance: row.querySelector('[data-deposit-field="balance"]')?.value || 0,
            type: row.querySelector('[data-deposit-field="type"]')?.value || 'free',
            rate: row.querySelector('[data-deposit-field="rate"]')?.value || 0,
            monthsToMaturity: row.querySelector('[data-deposit-field="monthsToMaturity"]')?.value ?? ''
        })) : [];
    const goals = Array.from(goalRowsContainer.querySelectorAll('.planner-goal-row')).map((row)=>({
            label: row.querySelector('[data-goal-field="label"]')?.value || '',
            amount: row.querySelector('[data-goal-field="amount"]')?.value || 0,
            years: row.querySelector('[data-goal-field="years"]')?.value || 0
        }));
    const accounts = accountRowsContainer ? Array.from(accountRowsContainer.querySelectorAll('.planner-account-row')).map((row)=>({
            label: row.querySelector('[data-account-field="label"]')?.value || '',
            balance: row.querySelector('[data-account-field="balance"]')?.value || 0,
            interestRate: row.querySelector('[data-account-field="interestRate"]')?.value || 0
        })) : [];
    const normalizedAccounts = (0, $6YR52.normalizeAccounts)(accounts);
    const totalCheckingBalance = normalizedAccounts.reduce((sum, account)=>sum + account.balance, 0);
    const checkingInterest = normalizedAccounts.some((account)=>account.interestRate > 0) ? 'yes_small' : 'no';
    const noInvestments = document.getElementById('investmentsStatus')?.value === 'none';
    // La risposta grezza alla domanda sul fondo (none / yes / suggest); nel payload
    // viaggia anche lo status derivato (none/partial/complete) per l'engine
    const emergencyClaim = document.getElementById('emergencyStatus')?.value ?? '';
    // Chi si fa consigliare resta nel flusso del consiglio: la proposta applicata
    // riempie le stesse caselle, quindi "suggest" con un totale > 0 è un fondo dichiarato
    const claimsFund = emergencyClaim === 'yes' || emergencyClaim === 'suggest';
    // La composizione per posto: il totale diventa l'importo del fondo;
    // posizione e conto si derivano da dove l'utente ha messo le cifre
    const normalizedDeposits = (0, $6YR52.normalizeDeposits)(deposits);
    const emergencySplit = {
        accounts: {},
        deposits: {},
        other: 0
    };
    const claimParts = [];
    let emergencySplitTotal = 0;
    if (claimsFund) document.querySelectorAll('#emergencySplitRows [data-split-kind]').forEach((input)=>{
        const amount = (0, $bdDJG.clampNumber)(input.value);
        if (amount <= 0) return;
        emergencySplitTotal += amount;
        claimParts.push({
            kind: input.dataset.splitKind,
            key: input.dataset.splitKey
        });
        if (input.dataset.splitKind === 'other') emergencySplit.other = amount;
        else emergencySplit[input.dataset.splitKind][input.dataset.splitKey] = amount;
    });
    let emergencyLocation = '';
    let emergencyAccount = '';
    if (claimsFund && claimParts.length === 1) {
        const part = claimParts[0];
        if (part.kind === 'accounts') {
            emergencyLocation = 'checking';
            emergencyAccount = part.key;
        } else if (part.kind === 'deposits') emergencyLocation = `deposit_${normalizedDeposits[Number(part.key)]?.type || 'free'}`;
        else emergencyLocation = 'other';
    } else if (claimsFund && claimParts.length > 1) emergencyLocation = 'split';
    // I campi scalari si leggono dal registro (id input = chiave dati);
    // qui sotto restano solo le letture con logica dedicata
    const scalars = {};
    $3e790f855f3f746b$var$FIELDS.forEach((field)=>{
        if (field.manual) return;
        scalars[field.id] = document.getElementById(field.id)?.value;
    });
    const data = {
        ...scalars,
        accounts: normalizedAccounts,
        checkingBalance: totalCheckingBalance,
        accountCount: normalizedAccounts.length,
        deposits: normalizedDeposits,
        checkingInterest: checkingInterest,
        emergencyClaim: emergencyClaim,
        emergencyAmount: claimsFund ? emergencySplitTotal : 0,
        emergencyLocation: emergencyLocation,
        emergencyAccount: emergencyAccount,
        emergencySplit: claimsFund && claimParts.length > 1 ? emergencySplit : null,
        // Senza investimenti il dettaglio si salta: eventuali valori inseriti prima non contano
        investStocks: noInvestments ? 0 : document.getElementById('investStocks')?.value,
        investEtf: noInvestments ? 0 : document.getElementById('investEtf')?.value,
        investFunds: noInvestments ? 0 : document.getElementById('investFunds')?.value,
        investCrypto: noInvestments ? 0 : document.getElementById('investCrypto')?.value,
        investCash: noInvestments ? 0 : document.getElementById('investCash')?.value,
        investCashRate: noInvestments ? 0 : document.getElementById('investCashRate')?.value,
        investDeposit: 0,
        checkupDate: new Date().toISOString(),
        previousScore: (0, $bdDJG.clampNumber)(document.getElementById('previousScore')?.value) || undefined,
        previousDate: document.getElementById('previousDate')?.value || undefined,
        goals: goals
    };
    // Completo o parziale non si chiede più: si misura sul target del profilo
    data.emergencyStatus = !claimsFund || emergencySplitTotal <= 0 ? 'none' : emergencySplitTotal >= (0, $6YR52.getEmergencyFundTarget)(data) ? 'complete' : 'partial';
    // Senza debiti dichiarati gli importi non contano, anche se compilati prima
    if (data.hasDebts === 'none') [
        'debtMortgageAmount',
        'debtMortgageRate',
        'debtPersonalAmount',
        'debtPersonalRate',
        'debtRevolvingAmount',
        'debtRevolvingRate',
        'debtCarAmount',
        'debtCarRate'
    ].forEach((key)=>{
        data[key] = 0;
    });
    return data;
}
function $3e790f855f3f746b$var$createGoalRow(goal = {}) {
    const row = document.createElement('div');
    row.className = 'planner-goal-row';
    row.innerHTML = `
    <div class="input-group">
      <label>Descrizione</label>
      <input type="text" data-goal-field="label" value="${goal.label || ''}" placeholder="es. Auto, master, ristrutturazione">
    </div>
    <div class="input-group">
      <label>Importo</label>
      <input type="number" data-goal-field="amount" min="0" step="100" value="${(0, $bdDJG.clampNumber)(goal.amount)}">
    </div>
    <div class="input-group">
      <label>Tra quanti anni?</label>
      <input type="number" data-goal-field="years" min="0.5" step="0.5" value="${(0, $bdDJG.clampNumber)(goal.years)}">
    </div>
    <button type="button" class="planner-row-remove" data-remove-goal aria-label="Rimuovi spesa" title="Rimuovi"><i class="ph ph-trash" aria-hidden="true"></i></button>
  `;
    row.querySelector('[data-remove-goal]').addEventListener('click', ()=>row.remove());
    return row;
}
function $3e790f855f3f746b$var$createDepositRow(deposit = {}) {
    const row = document.createElement('div');
    row.className = 'planner-account-row planner-deposit-row';
    row.innerHTML = `
    <div class="input-group">
      <label>Nome</label>
      <input type="text" data-deposit-field="label" value="${deposit.label || ''}" placeholder="es. Banca X">
    </div>
    <div class="input-group">
      <label>Saldo</label>
      <input type="number" data-deposit-field="balance" min="0" step="100" value="${(0, $bdDJG.clampNumber)(deposit.balance)}">
    </div>
    <div class="input-group">
      <label>Tipo</label>
      <select data-deposit-field="type">
        <option value="free"${deposit.type === 'free' || !deposit.type ? ' selected' : ''}>Libero</option>
        <option value="withdrawable"${deposit.type === 'withdrawable' ? ' selected' : ''}>Svincolabile</option>
        <option value="bound"${deposit.type === 'bound' ? ' selected' : ''}>Vincolato</option>
      </select>
    </div>
    <div class="input-group">
      <label>Tasso annuo lordo %</label>
      <input type="number" data-deposit-field="rate" min="0" step="0.1" value="${(0, $bdDJG.clampNumber)(deposit.rate)}">
    </div>
    <div class="input-group" data-deposit-maturity>
      <label>Si svincola tra (mesi)</label>
      <input type="number" data-deposit-field="monthsToMaturity" min="0" step="1" value="${deposit.monthsToMaturity === null || deposit.monthsToMaturity === undefined ? '' : deposit.monthsToMaturity}">
    </div>
    <button type="button" class="planner-row-remove" data-remove-deposit aria-label="Rimuovi deposito" title="Rimuovi"><i class="ph ph-trash" aria-hidden="true"></i></button>
  `;
    const typeSelect = row.querySelector('[data-deposit-field="type"]');
    const maturityGroup = row.querySelector('[data-deposit-maturity]');
    const syncMaturity = ()=>{
        maturityGroup.style.display = typeSelect.value === 'bound' ? '' : 'none';
    };
    typeSelect.addEventListener('change', syncMaturity);
    syncMaturity();
    row.querySelector('[data-remove-deposit]').addEventListener('click', ()=>row.remove());
    return row;
}
function $3e790f855f3f746b$var$createAccountRow(account = {}) {
    const row = document.createElement('div');
    row.className = 'planner-account-row';
    row.innerHTML = `
    <div class="input-group">
      <label>Conto</label>
      <input type="text" data-account-field="label" value="${account.label || ''}" placeholder="es. Fineco, Intesa, libretto postale">
    </div>
    <div class="input-group">
      <label>Liquidit\xe0</label>
      <input type="number" data-account-field="balance" min="0" step="100" value="${(0, $bdDJG.clampNumber)(account.balance)}">
    </div>
    <div class="input-group">
      <label>Interessi sul conto (% annuo lordo) <button type="button" class="planner-info-toggle" data-info-toggle aria-expanded="false" aria-label="Cosa sono gli interessi sul conto?"><i class="ph ph-info"></i></button></label>
      <input type="number" data-account-field="interestRate" min="0" step="0.1" value="${(0, $bdDJG.clampNumber)(account.interestRate)}">
      <p class="planner-field-note" data-info-note hidden>Alcuni conti correnti, detti remunerati, riconoscono interessi sui soldi che restano sul conto, come farebbe un conto deposito. La maggior parte dei conti non lo fa: se \xe8 il tuo caso, lascia 0. Il tasso lo trovi nell'app o nel foglio informativo della banca.</p>
    </div>
    <button type="button" class="planner-row-remove" data-remove-account aria-label="Rimuovi conto" title="Rimuovi"><i class="ph ph-trash" aria-hidden="true"></i></button>
  `;
    row.querySelector('[data-remove-account]').addEventListener('click', ()=>row.remove());
    return row;
}
function $3e790f855f3f746b$var$validateStep(stepNumber, data) {
    const requiredFields = $3e790f855f3f746b$var$FIELDS.filter((field)=>field.step === stepNumber && field.required && field.stepRequired !== false);
    const missing = requiredFields.filter((field)=>{
        const value = data[field.id];
        return value === '' || value === undefined || value === null;
    }).map((field)=>field.id);
    if (stepNumber === 3 && (!Array.isArray(data.accounts) || data.accounts.length === 0)) return 'Inserisci almeno un conto corrente.';
    if (stepNumber === 3) data.accounts = data.accounts.map((account, index)=>({
            ...account,
            label: account.label || `Conto ${index + 1}`
        }));
    if (stepNumber === 3 && data.accounts.some((account)=>account.balance < 0 || account.interestRate < 0)) return "Inserisci valori validi per liquidit\xe0 e tasso di ogni conto corrente.";
    if (stepNumber === 4 && $3e790f855f3f746b$var$hasPendingProposal(data)) return 'Per il fondo emergenza accetta la proposta, oppure indica tu quanto e dove.';
    if (stepNumber === 4 && data.emergencyClaim === 'yes' && (0, $bdDJG.clampNumber)(data.emergencyAmount) <= 0) return 'Indica quanto tieni da parte per le emergenze e in quale posto.';
    if (stepNumber === 2 && (0, $bdDJG.clampNumber)(data.monthlyIncome) === 0 && (0, $6YR52.getMonthlyExpenses)(data) === 0) return 'Inserisci almeno reddito o spese realistiche per poter generare un piano utile.';
    if (missing.length > 0) return 'Completa tutti i campi richiesti prima di continuare.';
    return null;
}
const $3e790f855f3f746b$var$hasValue = (value)=>value !== '' && value !== undefined && value !== null;
// Regole di validazione che non sono un semplice "campo obbligatorio":
// obblighi condizionali, coppie importo/tasso, controlli sugli array.
// Girano DOPO i required del registro per lo stesso substep.
// C'è una proposta in sospeso solo se una riserva proponibile esiste davvero:
// chi parte da zero prosegue senza conferme (il payload risulta senza fondo)
const $3e790f855f3f746b$var$hasPendingProposal = (data)=>{
    if (data.emergencyClaim !== 'suggest' || (0, $bdDJG.clampNumber)(data.emergencyAmount) > 0) return false;
    const probe = (0, $6YR52.computePlan)({
        ...data,
        emergencyClaim: 'none',
        emergencyStatus: 'none',
        emergencyAmount: 0,
        emergencyLocation: '',
        emergencyAccount: '',
        emergencySplit: null
    });
    return Boolean(probe.metrics.implicitEmergency);
};
const $3e790f855f3f746b$var$SUBSTEP_RULES = {
    '2:essential': (data)=>(0, $bdDJG.clampNumber)(data.expenseEssential) <= 0 ? 'Inserisci le spese necessarie mensili (o stimale con l\'aiuto delle categorie).' : null,
    '3:accounts': (data)=>Array.isArray(data.accounts) && data.accounts.length > 0 ? null : 'Inserisci almeno un conto corrente.',
    '4:emergency_status': (data)=>{
        if ($3e790f855f3f746b$var$hasPendingProposal(data)) return 'Accetta la proposta, oppure indica tu quanto e dove nelle caselle.';
        if (data.emergencyClaim === 'yes' && (0, $bdDJG.clampNumber)(data.emergencyAmount) <= 0) return 'Indica quanto tieni da parte per le emergenze e in quale posto.';
        return null;
    },
    '4:deposit': (data)=>Array.isArray(data.deposits) && data.deposits.some((deposit)=>deposit.balance < 0 || deposit.rate < 0) ? 'Controlla saldo e tasso dei conti deposito.' : null,
    '5:mortgage': (data)=>(0, $bdDJG.clampNumber)(data.debtMortgageAmount) > 0 && (0, $bdDJG.clampNumber)(data.debtMortgageRate) <= 0 ? 'Se hai un mutuo residuo, inserisci anche il suo tasso.' : null,
    '5:personal': (data)=>(0, $bdDJG.clampNumber)(data.debtPersonalAmount) > 0 && (0, $bdDJG.clampNumber)(data.debtPersonalRate) <= 0 ? 'Se hai un prestito personale residuo, inserisci anche il suo tasso.' : null,
    '5:revolving_car': (data)=>{
        if ((0, $bdDJG.clampNumber)(data.debtRevolvingAmount) > 0 && (0, $bdDJG.clampNumber)(data.debtRevolvingRate) <= 0) return 'Se hai una carta revolving, inserisci anche il suo tasso.';
        if ((0, $bdDJG.clampNumber)(data.debtCarAmount) > 0 && (0, $bdDJG.clampNumber)(data.debtCarRate) <= 0) return 'Se hai un finanziamento auto residuo, inserisci anche il suo tasso.';
        return null;
    },
    // Con una polizza dichiarata serve il valore (sta nel rendiconto annuale);
    // per chi non sa che polizza ha, anche il valore puo' mancare
    '7:status_pension': (data)=>[
            'guaranteed',
            'unit_linked'
        ].includes(data.lifeInsurance) && (0, $bdDJG.clampNumber)(data.lifeInsuranceValue) <= 0 ? 'Indica il valore attuale della polizza, anche approssimativo: lo trovi nel rendiconto annuale.' : null
};
function $3e790f855f3f746b$var$validateSubstep(stepNumber, substepKey, data) {
    // Prima i campi obbligatori del registro, nell'ordine in cui sono definiti
    for (const field of $3e790f855f3f746b$var$FIELDS){
        if (field.step !== stepNumber || field.substep !== substepKey || !field.required) continue;
        if (!$3e790f855f3f746b$var$hasValue(data[field.id])) return field.required;
    }
    const rule = $3e790f855f3f746b$var$SUBSTEP_RULES[`${stepNumber}:${substepKey}`];
    return rule ? rule(data) : null;
}
function $3e790f855f3f746b$var$updateWizardPreview(data) {
    const expensesPreview = document.getElementById('expensesPreview');
    const cashflowPreview = document.getElementById('cashflowPreview');
    if (expensesPreview) expensesPreview.textContent = (0, $bdDJG.euro)((0, $6YR52.getMonthlyExpenses)(data));
    if (cashflowPreview) cashflowPreview.textContent = (0, $bdDJG.euro)((0, $6YR52.getCashFlow)(data));
    const strategyPreview = document.getElementById('strategyPreview');
    if (strategyPreview) {
        const plan = (0, $6YR52.computePlan)(data);
        const totalCheckingBalance = (0, $6YR52.getCheckingBalance)(data);
        const previewDeposits = (0, $6YR52.getDeposits)(data);
        const depositInfo = previewDeposits.length > 0 ? `<p><strong>Conti deposito:</strong> ${(0, $bdDJG.euro)((0, $6YR52.getTotalDepositBalance)(data))} su ${previewDeposits.length} ${previewDeposits.length === 1 ? 'conto' : 'conti'}</p>` : '';
        strategyPreview.innerHTML = `
      <p><strong>Spese mensili stimate:</strong> ${(0, $bdDJG.euro)(plan.metrics.expenses)}</p>
      <p><strong>Margine mensile:</strong> ${(0, $bdDJG.euro)(plan.metrics.cashFlow)} (${(0, $bdDJG.percent)(plan.metrics.savingsRate)})</p>
      <p><strong>Conti correnti:</strong> ${(0, $bdDJG.euro)(totalCheckingBalance)} su ${plan.metrics.accounts.length} conti</p>
      <p><strong>Fondo emergenza consigliato:</strong> ${(0, $bdDJG.euro)(plan.metrics.emergencyTarget)}</p>
      ${plan.metrics.emergencyCurrent > 0 ? `<p><strong>Fondo emergenza attuale:</strong> ${(0, $bdDJG.euro)(plan.metrics.emergencyCurrent)}${plan.data.emergencyLocation ? ' (' + $3e790f855f3f746b$var$FIELD_BY_ID.emergencyLocation.options[plan.data.emergencyLocation] + ')' : ''}</p>` : ''}
      ${depositInfo}
      <p><strong>Blocco principale al lungo termine:</strong> ${plan.metrics.longTermInvestingAllowed ? 'nessuno' : plan.metrics.longTermBlockReason}</p>
    `;
    }
}
function $3e790f855f3f746b$var$hydrateWizardForm(savedData, goalRowsContainer) {
    const accountRowsContainer = document.getElementById('accountRows');
    if (!savedData) return;
    Object.entries(savedData).forEach(([key, value])=>{
        if (key === 'goals' || key === 'accounts' || key === 'deposits') return;
        const field = document.getElementById(key);
        if (field) field.value = value;
    });
    // Se le categorie di stima erano state usate, il pannello torna aperto
    document.querySelectorAll('.planner-estimate-helper').forEach((helper)=>{
        const used = Array.from(helper.querySelectorAll('[data-estimate-field]')).some((input)=>(0, $bdDJG.clampNumber)(input.value) > 0);
        if (used) helper.open = true;
    });
    // I payload storici non hanno la domanda-cancello sui debiti: si deriva dagli importi
    const hasDebtsSelect = document.getElementById('hasDebts');
    if (hasDebtsSelect && !savedData.hasDebts) {
        const anyDebt = [
            'debtMortgageAmount',
            'debtPersonalAmount',
            'debtRevolvingAmount',
            'debtCarAmount'
        ].some((key)=>(0, $bdDJG.clampNumber)(savedData[key]) > 0);
        if (anyDebt || savedData.checkupDate) hasDebtsSelect.value = anyDebt ? 'yes' : 'none';
    }
    // La risposta grezza alla domanda sul fondo: dai payload nuovi arriva com'è,
    // da quelli storici si mappa (partial/complete -> "sì, ti indico quanto e dove")
    const claimSelect = document.getElementById('emergencyStatus');
    if (claimSelect) claimSelect.value = savedData.emergencyClaim ?? (savedData.emergencyStatus === 'none' ? 'none' : savedData.emergencyStatus ? 'yes' : '');
    // La composizione si riapplica in syncConditionalFields; per i payload storici
    // (importo + posizione, senza composizione) la sintetizziamo sulla casella giusta
    const emergencySplitRowsBox = document.getElementById('emergencySplitRows');
    if (emergencySplitRowsBox) {
        let savedSplit = savedData.emergencySplit || null;
        const savedAmount = (0, $bdDJG.clampNumber)(savedData.emergencyAmount);
        if (!savedSplit && savedData.emergencyStatus && savedData.emergencyStatus !== 'none' && savedAmount > 0) {
            const location = savedData.emergencyLocation || '';
            if (location === 'checking') {
                const savedAccounts = (0, $6YR52.getCheckingAccounts)(savedData);
                const declared = savedData.emergencyAccount !== '' && savedData.emergencyAccount !== undefined ? Number(savedData.emergencyAccount) : NaN;
                const chosen = Number.isInteger(declared) ? declared : savedAccounts.reduce((best, account, index)=>account.interestRate > (savedAccounts[best]?.interestRate || 0) ? index : best, 0);
                savedSplit = {
                    accounts: {
                        [chosen]: savedAmount
                    },
                    deposits: {},
                    other: 0
                };
            } else if (location.startsWith('deposit')) {
                const savedDeposits = (0, $6YR52.getDeposits)(savedData);
                const type = location.replace('deposit_', '');
                let index = savedDeposits.findIndex((deposit)=>deposit.type === type);
                if (index < 0 && savedDeposits.length) index = 0;
                savedSplit = index >= 0 ? {
                    accounts: {},
                    deposits: {
                        [index]: savedAmount
                    },
                    other: 0
                } : {
                    accounts: {},
                    deposits: {},
                    other: savedAmount
                };
            } else savedSplit = {
                accounts: {},
                deposits: {},
                other: savedAmount
            };
        }
        if (savedSplit) emergencySplitRowsBox.dataset.saved = JSON.stringify(savedSplit);
    }
    // Dati salvati prima dello split necessarie/discrezionali: ricostruisci il totale
    const essentialField = document.getElementById('expenseEssential');
    if (essentialField && !essentialField.value) {
        const legacyEssential = (0, $6YR52.getEssentialExpenses)(savedData);
        if (legacyEssential > 0) essentialField.value = legacyEssential;
    }
    if (accountRowsContainer) {
        accountRowsContainer.innerHTML = '';
        (0, $6YR52.getCheckingAccounts)(savedData).forEach((account)=>{
            accountRowsContainer.appendChild($3e790f855f3f746b$var$createAccountRow(account));
        });
        if (!accountRowsContainer.children.length) accountRowsContainer.appendChild($3e790f855f3f746b$var$createAccountRow());
    }
    const depositRowsContainer = document.getElementById('depositRows');
    if (depositRowsContainer) {
        depositRowsContainer.innerHTML = '';
        (0, $6YR52.getDeposits)(savedData).forEach((deposit)=>{
            depositRowsContainer.appendChild($3e790f855f3f746b$var$createDepositRow(deposit));
        });
    }
    goalRowsContainer.innerHTML = '';
    (0, $6YR52.normalizeGoals)(savedData.goals || []).forEach((goal)=>{
        goalRowsContainer.appendChild($3e790f855f3f746b$var$createGoalRow(goal));
    });
    if (!goalRowsContainer.children.length) goalRowsContainer.appendChild($3e790f855f3f746b$var$createGoalRow());
}
function $3e790f855f3f746b$var$renderStepRecap(stepNumber, onNavigate) {
    const data = $3e790f855f3f746b$var$readWizardData(document.getElementById('goalRows'));
    const container = document.querySelector(`[data-recap-for="${stepNumber}"]`);
    if (!container) return;
    // Riga di riepilogo di un campo del registro: [etichetta, valore formattato, substep].
    // Le righe calcolate (totali, condizionali) restano definite a mano qui sotto.
    const fieldRecap = (id, formatValue)=>{
        const field = $3e790f855f3f746b$var$FIELD_BY_ID[id];
        const raw = data[id];
        let value = null;
        if ($3e790f855f3f746b$var$hasValue(raw) && raw !== 0) {
            if (formatValue) value = formatValue(raw);
            else if (field.options) value = field.options[raw] !== undefined ? field.options[raw] : raw;
            else if (field.euro) value = (0, $bdDJG.euro)((0, $bdDJG.clampNumber)(raw));
            else value = raw;
        }
        return [
            field.recap,
            value,
            field.substep
        ];
    };
    const items = {
        1: [
            fieldRecap('age', (value)=>`${value} anni`),
            fieldRecap('workStatus'),
            fieldRecap('familyStatus'),
            fieldRecap('dependents'),
            [
                'Entrate del nucleo',
                [
                    'couple',
                    'with_children',
                    'separated'
                ].includes(data.familyStatus) ? data.householdEarners === 'two' ? "Due o pi\xf9" : 'Una sola' : null,
                'family'
            ],
            [
                'Polizza TCM',
                (0, $bdDJG.clampNumber)(data.dependents) > 0 ? fieldRecap('hasTcm')[1] : null,
                'family'
            ],
            fieldRecap('housingStatus')
        ],
        2: [
            fieldRecap('monthlyIncome'),
            fieldRecap('expenseEssential'),
            fieldRecap('expenseDiscretionary'),
            [
                'Totale uscite mensili',
                (0, $bdDJG.euro)((0, $6YR52.getMonthlyExpenses)(data)),
                'essential'
            ]
        ],
        3: [
            [
                'Conti correnti',
                data.accounts?.length ? `${data.accounts.length} conti, ${(0, $bdDJG.euro)(data.checkingBalance)}` : null,
                'accounts'
            ],
            fieldRecap('accountFee'),
            fieldRecap('creditCardFee')
        ],
        4: [
            fieldRecap('emergencyStatus'),
            [
                'Importo dedicato',
                data.emergencyAmount ? (0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.emergencyAmount)) : null,
                'emergency_status'
            ],
            [
                'Mesi di spese coperti',
                (()=>{
                    const months = (0, $6YR52.getEmergencyFundMonths)(data);
                    const label = months === 0.5 ? 'Mezzo mese' : `${months} mesi`;
                    return (0, $6YR52.getChosenEmergencyMonths)(data) !== null ? `${label} (scelta tua)` : `${label} (consigliati)`;
                })(),
                'emergency_status'
            ],
            [
                'Conti deposito',
                (0, $6YR52.getDeposits)(data).length ? `${(0, $6YR52.getDeposits)(data).length} ${(0, $6YR52.getDeposits)(data).length === 1 ? 'conto' : 'conti'}, ${(0, $bdDJG.euro)((0, $6YR52.getTotalDepositBalance)(data))}` : 'Nessuno',
                'deposit'
            ],
            [
                'Posizione fondo',
                data.emergencyStatus === 'none' ? null : fieldRecap('emergencyLocation')[1],
                'emergency_status'
            ]
        ],
        5: data.hasDebts === 'none' ? [
            [
                'Debiti',
                'Nessuno',
                'debt_status'
            ]
        ] : [
            [
                'Mutuo',
                `${(0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.debtMortgageAmount))} al ${(0, $bdDJG.clampNumber)(data.debtMortgageRate)}%`,
                'mortgage'
            ],
            [
                'Prestito personale',
                `${(0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.debtPersonalAmount))} al ${(0, $bdDJG.clampNumber)(data.debtPersonalRate)}%`,
                'personal'
            ],
            [
                'Carta revolving',
                `${(0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.debtRevolvingAmount))} al ${(0, $bdDJG.clampNumber)(data.debtRevolvingRate)}%`,
                'revolving_car'
            ],
            [
                'Finanziamento auto',
                `${(0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.debtCarAmount))} al ${(0, $bdDJG.clampNumber)(data.debtCarRate)}%`,
                'revolving_car'
            ]
        ],
        6: (()=>{
            const bondsRow = [
                'Titoli di Stato e obbligazioni',
                (0, $bdDJG.clampNumber)(data.investBonds) > 0 ? (0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.investBonds)) : 'Nessuno',
                'money_market'
            ];
            const moneyMarketRow = [
                'ETF monetari',
                (0, $bdDJG.clampNumber)(data.investMoneyMarket) > 0 ? (0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.investMoneyMarket)) : 'Nessuno',
                'money_market'
            ];
            const postalBondsRow = [
                'Buoni fruttiferi postali',
                (0, $bdDJG.clampNumber)(data.investPostalBonds) > 0 ? (0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.investPostalBonds)) : 'Nessuno',
                'money_market'
            ];
            const goals = (data.goals || []).filter((goal)=>(0, $bdDJG.clampNumber)(goal.amount) > 0 || (goal.label || '').trim());
            if (!goals.length) return [
                [
                    'Spese previste',
                    'Nessuna',
                    'goals_list'
                ],
                bondsRow,
                moneyMarketRow,
                postalBondsRow
            ];
            return [
                ...goals.map((goal, index)=>{
                    // Gli anni con decimali si leggono male: si mostrano come mesi
                    const months = Math.round((0, $bdDJG.clampNumber)(goal.years) * 12);
                    const wholeYears = Math.floor(months / 12);
                    const restMonths = months % 12;
                    const parts = [];
                    if (wholeYears > 0) parts.push(`${wholeYears} ${wholeYears === 1 ? 'anno' : 'anni'}`);
                    if (restMonths > 0) parts.push(`${restMonths} ${restMonths === 1 ? 'mese' : 'mesi'}`);
                    const when = parts.length ? ` tra ${parts.join(' e ')}` : '';
                    return [
                        (goal.label || '').trim() || `Spesa ${index + 1}`,
                        `${(0, $bdDJG.euro)((0, $bdDJG.clampNumber)(goal.amount))}${when}`,
                        'goals_list'
                    ];
                }),
                bondsRow,
                moneyMarketRow,
                postalBondsRow
            ];
        })(),
        7: [
            fieldRecap('investmentsStatus'),
            fieldRecap('pensionFund'),
            fieldRecap('ral'),
            fieldRecap('hasBrokerAccount'),
            [
                'Totale investimenti',
                (()=>{
                    if (!data.investmentsStatus || data.investmentsStatus === 'none') return null;
                    const t = (0, $bdDJG.clampNumber)(data.investStocks) + (0, $bdDJG.clampNumber)(data.investEtf) + (0, $bdDJG.clampNumber)(data.investFunds) + (0, $bdDJG.clampNumber)(data.investCrypto);
                    return (0, $bdDJG.euro)(t);
                })(),
                'breakdown'
            ],
            [
                'Polizza di risparmio',
                [
                    'guaranteed',
                    'unit_linked',
                    'unknown'
                ].includes(data.lifeInsurance) ? `${(0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.lifeInsuranceValue))} (${$3e790f855f3f746b$var$FIELD_BY_ID.lifeInsurance.options[data.lifeInsurance]})` : null,
                'status_pension'
            ],
            [
                "Liquidit\xe0 sul broker",
                (0, $bdDJG.clampNumber)(data.investCash) > 0 ? (0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.investCash)) : null,
                'breakdown'
            ],
            fieldRecap('reactionDrop'),
            fieldRecap('checkFrequency')
        ],
        8: [
            [
                'Margine mensile',
                `${(0, $bdDJG.euro)((0, $6YR52.getCashFlow)(data))} (${(0, $bdDJG.percent)((0, $6YR52.getSavingsRate)(data))})`,
                'essential'
            ],
            (()=>{
                const m = (0, $6YR52.computePlan)(data).metrics;
                // "Modifica" porta alla schermata da cui nasce il blocco (le chiavi
                // sono i testi esatti di longTermBlockReason nell'engine)
                const gotoByReason = {
                    'Debiti con tassi alti': 'debt_status',
                    'Fondo emergenza incompleto': 'emergency_status',
                    'Spese previste da finanziare entro 10 anni': 'goals_list',
                    'Tolleranza al rischio insufficiente': 'risk',
                    'Margine mensile insufficiente': 'essential'
                };
                return m.longTermInvestingAllowed ? [
                    'Blocco principale al lungo termine',
                    'Nessuno',
                    'status_pension'
                ] : [
                    'Blocco principale al lungo termine',
                    m.longTermBlockReason,
                    gotoByReason[m.longTermBlockReason] || 'status_pension'
                ];
            })()
        ]
    };
    const renderItems = (rows)=>rows.filter(([, value])=>value !== null).map(([label, value, substepKey])=>`<button type="button" class="planner-recap-item" data-recap-goto="${substepKey}">
        <span class="planner-recap-item__label">${label}</span>
        <span class="planner-recap-item__value">${value}</span>
        <span class="planner-recap-item__edit">Modifica</span>
      </button>`).join('');
    if (stepNumber === 8) // Riepilogo finale completo: tutte le risposte, raggruppate per sezione
    container.innerHTML = [
        `<div class="planner-recap-group"><h4>I tuoi numeri chiave</h4>${renderItems(items[8])}</div>`,
        ...[
            1,
            2,
            3,
            4,
            5,
            6,
            7
        ].map((step)=>`<div class="planner-recap-group"><h4>${$3e790f855f3f746b$var$STEP_NAMES[step - 1]}</h4>${renderItems(items[step])}</div>`)
    ].join('');
    else container.innerHTML = renderItems(items[stepNumber] || []);
    container.querySelectorAll('.planner-recap-item').forEach((item)=>{
        item.addEventListener('click', ()=>{
            const target = item.dataset.recapGoto;
            const targetStep = Object.entries($3e790f855f3f746b$var$SUBSTEP_CONFIG).find(([, substeps])=>substeps.includes(target));
            if (!targetStep || typeof onNavigate !== 'function') return;
            const [targetStepNumber, targetSubsteps] = targetStep;
            const targetIndex = targetSubsteps.indexOf(target);
            if (targetIndex >= 0) onNavigate(Number(targetStepNumber), targetIndex);
        });
    });
}
function $3e790f855f3f746b$var$initWizard() {
    const form = document.getElementById('financialPlannerForm');
    if (!form) return;
    const steps = Array.from(document.querySelectorAll('.planner-step'));
    const stepLabels = Array.from(document.querySelectorAll('.planner-step-list li'));
    const errorBox = document.getElementById('plannerError');
    const nextButton = document.getElementById('nextStepButton');
    const prevButton = document.getElementById('prevStepButton');
    const stepLabel = document.getElementById('plannerStepLabel');
    const stepPercent = document.getElementById('plannerStepPercent');
    const heroStep = document.getElementById('plannerHeroStep');
    const heroContext = document.getElementById('plannerHeroContext');
    const substepCounter = document.getElementById('plannerSubstepCounter');
    const questionKicker = document.getElementById('plannerQuestionKicker');
    const questionTitle = document.getElementById('plannerQuestionTitle');
    const questionIcon = document.getElementById('plannerQuestionIcon');
    const questionCard = document.querySelector('.planner-question-card');
    const progressText = document.getElementById('plannerProgressText');
    const progressPercent = document.getElementById('plannerProgressPercent');
    const progressBar = document.getElementById('plannerProgressBar');
    const questionWhyBlock = document.querySelector('.planner-question-why');
    const accountRows = document.getElementById('accountRows');
    const goalRows = document.getElementById('goalRows');
    const addAccountButton = document.getElementById('addAccountButton');
    const addGoalButton = document.getElementById('addGoalButton');
    const questionWhy = document.getElementById('plannerQuestionWhy');
    const emergencyStatus = document.getElementById('emergencyStatus');
    const investmentsStatus = document.getElementById('investmentsStatus');
    let currentStep = 1;
    let currentSubstepIndex = 0;
    // Salto dal riepilogo a un campo: qui ricordiamo dove tornare dopo la modifica
    let returnTarget = null;
    const editRequested = new URLSearchParams(window.location.search).get('edit') === '1';
    const getSubsteps = (step)=>$3e790f855f3f746b$var$SUBSTEP_CONFIG[step] || [];
    const getTotalSubsteps = (step)=>getSubsteps(step).length;
    // Substep che si saltano in base alle risposte precedenti (regole dichiarative)
    const isSubstepSkipped = (step, key)=>{
        const rule = $3e790f855f3f746b$var$SUBSTEP_SKIP_RULES[`${step}:${key}`];
        return rule ? rule((id)=>document.getElementById(id)?.value) : false;
    };
    const flowSubsteps = Object.entries($3e790f855f3f746b$var$SUBSTEP_CONFIG).flatMap(([step, keys])=>keys.filter((key)=>!(key === 'intro' && keys.length > 1)).map((key)=>({
                step: Number(step),
                key: key
            })));
    const getActiveSubstepMeta = ()=>{
        const substepKeys = getSubsteps(currentStep);
        const key = substepKeys[currentSubstepIndex];
        const activeStep = steps.find((s)=>Number(s.dataset.step) === currentStep);
        const activeSubstep = activeStep?.querySelector('.planner-substep.is-active');
        const copy = $3e790f855f3f746b$var$SUBSTEP_COPY[key] || $3e790f855f3f746b$var$SUBSTEP_COPY.intro;
        const label = activeSubstep?.querySelector('.planner-substep__label')?.textContent?.trim() || activeSubstep?.querySelector('h2')?.textContent?.trim() || $3e790f855f3f746b$var$SUBSTEP_LABELS[currentStep]?.[key] || $3e790f855f3f746b$var$STEP_NAMES[currentStep - 1] || '';
        const icon = $3e790f855f3f746b$var$SUBSTEP_ICONS[key] || 'sparkle';
        let flowIndex = flowSubsteps.findIndex((item)=>item.step === currentStep && item.key === key);
        if (flowIndex < 0 && key === 'intro') flowIndex = flowSubsteps.findIndex((item)=>item.step === currentStep);
        flowIndex = Math.max(0, flowIndex);
        return {
            key: key,
            title: copy.prompt || label,
            why: copy.why || '',
            label: label,
            icon: icon,
            flowIndex: flowIndex,
            flowTotal: flowSubsteps.length
        };
    };
    const updateSplitHint = ()=>{
        const hint = document.getElementById('emergencySplitHint');
        const box = document.getElementById('emergencySplitRows');
        if (!hint || !box) return;
        let total = 0;
        box.querySelectorAll('[data-split-kind]').forEach((input)=>{
            total += (0, $bdDJG.clampNumber)(input.value);
        });
        hint.textContent = total > 0 ? `Totale: ${(0, $bdDJG.euro)(total)}. Questo diventa l'importo del tuo fondo emergenza.` : 'Il totale di queste caselle diventa l\'importo del tuo fondo emergenza.';
    };
    const syncConditionalFields = ()=>{
        // Il quadro dei posti censiti: alla domanda sul fondo si risponde coi numeri davanti
        const potsBox = document.getElementById('emergencyPotsSummary');
        if (potsBox) {
            const summaryData = $3e790f855f3f746b$var$readWizardData(document.getElementById('goalRows'));
            const potsAccounts = summaryData.accounts || [];
            const potsDeposits = summaryData.deposits || [];
            const potsPieces = [];
            if (potsAccounts.length) potsPieces.push(`sui conti correnti <strong>${(0, $bdDJG.euro)(summaryData.checkingBalance)}</strong> (${potsAccounts.map((account, index)=>`${(0, $bdDJG.escapeHtml)(account.label || `Conto ${index + 1}`)} ${(0, $bdDJG.euro)(account.balance)}`).join(', ')})`);
            if (potsDeposits.length) potsPieces.push(`sui conti deposito <strong>${(0, $bdDJG.euro)((0, $6YR52.getTotalDepositBalance)(summaryData))}</strong>`);
            if (potsPieces.length) {
                const liquidityTarget = (0, $6YR52.getOperationalLiquidityTarget)(summaryData);
                potsBox.innerHTML = `<p><strong>Dove stanno oggi i tuoi soldi:</strong> ${potsPieces.join(" \xb7 ")}.</p>` + (liquidityTarget > 0 ? `<p>Per vivere il mese ti servono circa <strong>${(0, $bdDJG.euro)(liquidityTarget)}</strong> di liquidit\xe0: quella parte ha gi\xe0 un compito e non \xe8 fondo emergenza.</p>` : '');
                potsBox.hidden = false;
            } else {
                potsBox.innerHTML = '';
                potsBox.hidden = true;
            }
        }
        // "Sì": una casella per ogni conto e deposito, più "altrove"; il totale è il fondo
        const emergencyClaimGroup = document.getElementById('emergencyClaimGroup');
        const emergencySplitRowsBox = document.getElementById('emergencySplitRows');
        if (emergencyClaimGroup && emergencySplitRowsBox) {
            const claimValue = emergencyStatus?.value ?? '';
            // Le righe esistono anche in modalità consiglio (la proposta le riempie
            // dietro le quinte); si vedono con "sì" o quando l'utente vuole ritoccare
            const showSplit = claimValue === 'yes' || claimValue === 'suggest';
            emergencyClaimGroup.style.display = claimValue === 'yes' || claimValue === 'suggest' && document.getElementById('emergencySuggestBox')?.dataset.showBoxes === '1' ? '' : 'none';
            if (showSplit) {
                // I valori già digitati si conservano attraverso le ricostruzioni
                const currentValues = {};
                emergencySplitRowsBox.querySelectorAll('[data-split-kind]').forEach((input)=>{
                    currentValues[`${input.dataset.splitKind}:${input.dataset.splitKey}`] = input.value;
                });
                let savedSplit = null;
                if (emergencySplitRowsBox.dataset.saved) {
                    try {
                        savedSplit = JSON.parse(emergencySplitRowsBox.dataset.saved);
                    } catch (error) {
                        savedSplit = null;
                    }
                    delete emergencySplitRowsBox.dataset.saved;
                }
                const valueFor = (kind, key)=>{
                    const typed = currentValues[`${kind}:${key}`];
                    if (typed !== undefined && typed !== '') return typed;
                    if (kind === 'other') return savedSplit?.other || '';
                    return savedSplit?.[kind]?.[key] || '';
                };
                const rows = [];
                Array.from(document.querySelectorAll('#accountRows .planner-account-row')).forEach((row, index)=>{
                    const label = row.querySelector('[data-account-field="label"]')?.value?.trim() || `Conto ${index + 1}`;
                    const rate = (0, $bdDJG.clampNumber)(row.querySelector('[data-account-field="interestRate"]')?.value);
                    const balance = (0, $bdDJG.clampNumber)(row.querySelector('[data-account-field="balance"]')?.value);
                    rows.push({
                        kind: 'accounts',
                        key: String(index),
                        label: `Su ${label}${rate > 0 ? ' (remunerato)' : ''} \xb7 saldo ${(0, $bdDJG.euro)(balance)}`
                    });
                });
                Array.from(document.querySelectorAll('#depositRows .planner-account-row')).forEach((row, index)=>{
                    const label = row.querySelector('[data-deposit-field="label"]')?.value?.trim() || `Deposito ${index + 1}`;
                    const balance = (0, $bdDJG.clampNumber)(row.querySelector('[data-deposit-field="balance"]')?.value);
                    rows.push({
                        kind: 'deposits',
                        key: String(index),
                        label: `Su ${label} (deposito) \xb7 saldo ${(0, $bdDJG.euro)(balance)}`
                    });
                });
                // La casella "altrove" non si propone più: il fondo si mette su conti o
                // depositi. Resta visibile solo per i payload storici con un importo lì.
                if ((0, $bdDJG.clampNumber)(valueFor('other', '0')) > 0) rows.push({
                    kind: 'other',
                    key: '0',
                    label: 'Altrove (BOT, contanti, altro)'
                });
                emergencySplitRowsBox.innerHTML = '';
                rows.forEach((rowDef)=>{
                    const wrap = document.createElement('div');
                    wrap.className = 'input-group';
                    const label = document.createElement('label');
                    label.textContent = rowDef.label;
                    const input = document.createElement('input');
                    input.type = 'number';
                    input.min = '0';
                    input.step = '100';
                    input.dataset.splitKind = rowDef.kind;
                    input.dataset.splitKey = rowDef.key;
                    input.value = valueFor(rowDef.kind, rowDef.key);
                    wrap.appendChild(label);
                    wrap.appendChild(input);
                    emergencySplitRowsBox.appendChild(wrap);
                });
                updateSplitHint();
                if (!emergencySplitRowsBox.dataset.bound) {
                    emergencySplitRowsBox.dataset.bound = '1';
                    emergencySplitRowsBox.addEventListener('input', updateSplitHint);
                }
            }
        }
        // "Non saprei": prima la proposta (una sola), poi il perché. Chi si fa
        // consigliare resta in questo flusso: il sì riempie le caselle dietro le
        // quinte e qui compare la conferma, ritoccabile. Il "primo mattone" esiste
        // solo per chi non ha una riserva da cui partire.
        const suggestBox = document.getElementById('emergencySuggestBox');
        if (suggestBox && emergencyStatus) {
            if (emergencyStatus.value === 'suggest') {
                const draft = $3e790f855f3f746b$var$readWizardData(document.getElementById('goalRows'));
                const suggestMetrics = (0, $6YR52.computePlan)({
                    ...draft,
                    emergencyClaim: 'none',
                    emergencyStatus: 'none',
                    emergencyAmount: 0,
                    emergencyLocation: '',
                    emergencyAccount: '',
                    emergencySplit: null
                }).metrics;
                const proposal = suggestMetrics.implicitEmergency;
                const target = (0, $6YR52.getEmergencyFundTarget)(draft);
                const months = (0, $6YR52.getEmergencyFundMonths)(draft);
                const monthlyPace = Math.max(suggestMetrics.cashFlow, 0);
                const paceText = (missing)=>monthlyPace > 0 ? ` Al tuo ritmo di risparmio (~${(0, $bdDJG.euro)(monthlyPace)} al mese) ci arrivi in circa ${Math.ceil(missing / monthlyPace)} ${Math.ceil(missing / monthlyPace) === 1 ? 'mese' : 'mesi'}.` : '';
                if (proposal) {
                    const accessibleDeposits = (draft.deposits || []).filter((deposit)=>deposit.type === 'free' || deposit.type === 'withdrawable').reduce((sum, deposit)=>sum + deposit.balance, 0);
                    const fullAmount = Math.min(target, proposal.available);
                    // Allocazione deposits-first: la stessa logica riempie le caselle e racconta la proposta
                    const allocationFor = (amount)=>{
                        const parts = [];
                        let remainingDeposits = Math.min(accessibleDeposits, amount);
                        let remainingChecking = amount - remainingDeposits;
                        (draft.deposits || []).forEach((deposit, index)=>{
                            if (deposit.type !== 'free' && deposit.type !== 'withdrawable') return;
                            const take = Math.min(deposit.balance, remainingDeposits);
                            if (take > 0) {
                                parts.push({
                                    kind: 'deposits',
                                    key: String(index),
                                    amount: Math.round(take),
                                    label: `${deposit.label || `Deposito ${index + 1}`}`
                                });
                                remainingDeposits -= take;
                            }
                        });
                        remainingChecking += Math.max(remainingDeposits, 0);
                        (draft.accounts || []).map((account, index)=>({
                                account: account,
                                index: index
                            })).sort((a, b)=>(b.account.interestRate || 0) - (a.account.interestRate || 0)).forEach(({ account: account, index: index })=>{
                            const take = Math.min(account.balance || 0, remainingChecking);
                            if (take > 0) {
                                parts.push({
                                    kind: 'accounts',
                                    key: String(index),
                                    amount: Math.round(take),
                                    label: `${account.label || `Conto ${index + 1}`}${account.interestRate > 0 ? ' (remunerato)' : ''}`
                                });
                                remainingChecking -= take;
                            }
                        });
                        return parts;
                    };
                    const describeParts = (parts)=>parts.map((part)=>`${(0, $bdDJG.euro)(part.amount)} su ${(0, $bdDJG.escapeHtml)(part.label)}`).join(' e ');
                    const applyParts = (parts)=>{
                        const inputs = Array.from(document.querySelectorAll('#emergencySplitRows [data-split-kind]'));
                        inputs.forEach((input)=>{
                            input.value = '';
                        });
                        parts.forEach((part)=>{
                            const input = inputs.find((candidate)=>candidate.dataset.splitKind === part.kind && candidate.dataset.splitKey === part.key);
                            if (input) input.value = String(part.amount);
                        });
                    };
                    // Lo stato applicato si ricava dai numeri: sopravvive a ricariche e round-trip
                    const currentTotal = (0, $bdDJG.clampNumber)(draft.emergencyAmount);
                    let applied = currentTotal > 0 ? Math.abs(currentTotal - fullAmount) <= 1 ? 'full' : 'custom' : '';
                    const decision = suggestBox.dataset.decision || (currentTotal > 0 ? 'proposal' : '');
                    // Se i mesi cambiano dopo il sì alla proposta, questa segue il nuovo target
                    if (decision === 'proposal' && suggestBox.dataset.showBoxes !== '1' && currentTotal > 0 && Math.abs(currentTotal - fullAmount) > 1) {
                        applyParts(allocationFor(fullAmount));
                        applied = 'full';
                    }
                    const fullParts = allocationFor(fullAmount);
                    const monthsNote = (0, $6YR52.getChosenEmergencyMonths)(draft) !== null ? 'che hai scelto tu qui sopra' : 'suggeriti dal tuo profilo, li puoi cambiare qui sopra';
                    const whyText = fullAmount >= target ? `Perch\xe9: \xe8 il tuo target, cio\xe8 ${(0, $bdDJG.euro)((0, $6YR52.getMonthlyExpenses)(draft))} di spese per ${(0, $bdDJG.formatMonthsLabel)(months)} (${monthsNote}). E li hai gi\xe0: <strong>${(0, $bdDJG.euro)(proposal.available)}</strong> subito disponibili senza toccare la liquidit\xe0 che ti serve per il mese.` : `Ti servir\xe0 di pi\xf9: il tuo target \xe8 <strong>${(0, $bdDJG.euro)(target)}</strong>, cio\xe8 ${(0, $bdDJG.euro)((0, $6YR52.getMonthlyExpenses)(draft))} di spese per ${(0, $bdDJG.formatMonthsLabel)(months)} (${monthsNote}). Ma si parte da quello che c'\xe8: oggi hai <strong>${(0, $bdDJG.euro)(proposal.available)}</strong> subito disponibili senza toccare la liquidit\xe0 del mese. Segna questi, e il resto (${(0, $bdDJG.euro)(target - fullAmount)}) si costruisce col risparmio.${paceText(target - fullAmount)} Lo aggiornerai dai risultati.`;
                    suggestBox.innerHTML = `
            <p class="planner-suggest-lead"><strong>La nostra proposta:</strong> segna come fondo emergenza <strong>${(0, $bdDJG.euro)(fullAmount)}</strong>, cos\xec: ${describeParts(fullParts)}.</p>
            <p class="planner-field-hint">${whyText}</p>
            <div class="planner-suggest-options" role="radiogroup" aria-label="Come procediamo col fondo emergenza">
              <button type="button" role="radio" aria-checked="${decision === 'proposal'}" class="planner-suggest-option${decision === 'proposal' ? ' is-active' : ''}" data-suggest-decision="proposal"><strong>Va bene, segna ${(0, $bdDJG.euro)(fullAmount)} come fondo</strong><span>la proposta qui sopra, cos\xec com'\xe8${decision === 'proposal' ? '' : ' (potrai ritoccarla)'}</span></button>
              <button type="button" role="radio" aria-checked="${decision === 'self'}" class="planner-suggest-option${decision === 'self' ? ' is-active' : ''}" data-suggest-decision="self"><strong>Preferisco indicare io quanto e dove</strong><span>compili tu le caselle, una per ogni posto</span></button>
            </div>
            ${decision === 'proposal' && applied === 'full' ? `<p class="planner-suggest-done"><i class="ph ph-check-circle" aria-hidden="true"></i> Fatto: ${describeParts(fullParts)} segnati come fondo emergenza. <button type="button" class="planner-suggest-tweak" id="tweakSuggestBoxes">Ritocca cifre e posti</button></p>` : ''}
            ${applied === 'custom' ? `<p class="planner-suggest-done"><i class="ph ph-check-circle" aria-hidden="true"></i> Composizione personalizzata: totale ${(0, $bdDJG.euro)(currentTotal)}, nelle caselle qui sotto.</p>` : ''}`;
                    suggestBox.querySelectorAll('[data-suggest-decision]').forEach((button)=>{
                        button.addEventListener('click', ()=>{
                            if (button.dataset.suggestDecision === 'proposal') {
                                suggestBox.dataset.decision = 'proposal';
                                delete suggestBox.dataset.showBoxes;
                                applyParts(fullParts);
                            } else {
                                suggestBox.dataset.decision = 'self';
                                suggestBox.dataset.showBoxes = '1';
                                // Si riparte dalle caselle vuote: la composizione la decide l'utente
                                document.querySelectorAll('#emergencySplitRows [data-split-kind]').forEach((input)=>{
                                    input.value = '';
                                });
                            }
                            syncConditionalFields();
                            persistState();
                        });
                    });
                    suggestBox.querySelector('#tweakSuggestBoxes')?.addEventListener('click', ()=>{
                        suggestBox.dataset.showBoxes = '1';
                        syncConditionalFields();
                    });
                } else // Chi parte da zero non ha niente da scegliere: si spiega e si prosegue
                suggestBox.innerHTML = `
            <p class="planner-suggest-lead"><strong>Ti servir\xe0 circa ${(0, $bdDJG.euro)(target)}</strong>, cio\xe8 ${(0, $bdDJG.euro)((0, $6YR52.getMonthlyExpenses)(draft))} di spese per ${(0, $bdDJG.formatMonthsLabel)(months)}. Oggi non c'\xe8 ancora una riserva da cui partire, e va benissimo: si comincia da zero.</p>
            <p class="planner-field-hint">Non pensare al totale: concentrati sul primo mattone, <strong>${(0, $bdDJG.euro)((0, $6YR52.EMERGENCY_FIRST_MILESTONE))}</strong>. Copre la spesa imprevista tipica (un guasto, un dentista) ed \xe8 il gradino che cambia di pi\xf9 le cose.${paceText((0, $6YR52.EMERGENCY_FIRST_MILESTONE))}</p>
            <p class="planner-field-hint">Vai pure avanti: nel check-up risulterai senza fondo, e nei risultati trovi i traguardi passo passo per costruirlo. Aggiornerai le risposte man mano che cresce.</p>`;
                suggestBox.style.display = '';
            } else suggestBox.style.display = 'none';
        }
        // I mesi coperti si scelgono qui, in alternativa al consigliato: il target
        // (e quindi proposta e giudizio completo/parziale) si ricalcola subito
        const monthsChoice = document.getElementById('emergencyMonthsChoice');
        const monthsField = document.getElementById('emergencyMonths');
        if (monthsChoice && monthsField) {
            const monthsDraft = $3e790f855f3f746b$var$readWizardData(document.getElementById('goalRows'));
            const suggestedMonths = (0, $6YR52.getSuggestedEmergencyMonths)(monthsDraft);
            const chosenMonths = (0, $6YR52.getChosenEmergencyMonths)(monthsDraft);
            const suggestedShort = suggestedMonths === 0.5 ? "\xbd" : String(suggestedMonths);
            monthsChoice.innerHTML = `
        <div class="finance-emergency-months__row">
          <span class="finance-emergency-months__label" id="wizardEmergencyMonthsLabel">Quanti mesi di spese vuoi coperti?</span>
          <div class="finance-emergency-months__options" role="group" aria-labelledby="wizardEmergencyMonthsLabel">
            <button type="button" class="finance-emergency-months__option${chosenMonths === null ? ' is-active' : ''}" data-months="">Consigliato: ${suggestedShort}</button>
            ${[
                3,
                6,
                9,
                12
            ].map((m)=>`<button type="button" class="finance-emergency-months__option${chosenMonths === m ? ' is-active' : ''}" data-months="${m}">${m}</button>`).join('')}
          </div>
        </div>
        <span class="finance-emergency-months__hint">${(0, $6YR52.buildEmergencyMonthsHint)(monthsDraft)}</span>`;
            monthsChoice.querySelectorAll('.finance-emergency-months__option').forEach((button)=>{
                button.addEventListener('click', ()=>{
                    if (button.classList.contains('is-active')) return;
                    monthsField.value = button.dataset.months;
                    syncConditionalFields();
                    persistState();
                });
            });
        }
        const earnersGroup = document.querySelector('[data-show-if="householdEarners"]');
        const familySelect = document.getElementById('familyStatus');
        if (earnersGroup && familySelect) {
            const shared = [
                'couple',
                'with_children',
                'separated'
            ].includes(familySelect.value);
            earnersGroup.style.display = shared ? '' : 'none';
        }
        const brokerFeeGroup = document.querySelector('[data-show-if="hasBrokerAccount"]');
        const brokerSelect = document.getElementById('hasBrokerAccount');
        if (brokerFeeGroup && brokerSelect) brokerFeeGroup.style.display = brokerSelect.value === 'yes' ? '' : 'none';
        // La domanda sulla TCM ha senso solo con qualcuno a carico
        const tcmGroup = document.querySelector('[data-show-if="hasTcm"]');
        if (tcmGroup) tcmGroup.style.display = (0, $bdDJG.clampNumber)(document.getElementById('dependents')?.value) > 0 ? '' : 'none';
        // Il valore della polizza si chiede solo a chi una polizza ce l'ha
        const lifeValueGroup = document.querySelector('[data-show-if="lifeInsuranceValue"]');
        const lifeSelect = document.getElementById('lifeInsurance');
        if (lifeValueGroup && lifeSelect) lifeValueGroup.style.display = [
            'guaranteed',
            'unit_linked',
            'unknown'
        ].includes(lifeSelect.value) ? '' : 'none';
    };
    const scrollToPanelTop = ()=>{
        const panel = document.querySelector('.planner-panel');
        if (!panel) return;
        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        panel.scrollIntoView({
            behavior: prefersReduced ? 'auto' : 'smooth',
            block: 'start'
        });
    };
    const setSubstep = (step, substepIdx)=>{
        currentStep = step;
        currentSubstepIndex = substepIdx;
        updateStepUi();
        scrollToPanelTop();
    };
    // Navigazione da un riepilogo: si modifica il campo e si torna al riepilogo di partenza
    const jumpFromRecap = (step, substepIdx)=>{
        returnTarget = {
            step: currentStep,
            substepIndex: currentSubstepIndex
        };
        setSubstep(step, substepIdx);
    };
    const updateStepUi = ()=>{
        // Step visibility
        steps.forEach((step)=>step.classList.toggle('is-active', Number(step.dataset.step) === currentStep));
        stepLabels.forEach((item, index)=>item.classList.toggle('is-active', index + 1 === currentStep));
        // Substep visibility — match by position index
        const activeStep = steps.find((s)=>Number(s.dataset.step) === currentStep);
        if (activeStep) {
            const substeps = activeStep.querySelectorAll('.planner-substep');
            substeps.forEach((ss, idx)=>{
                ss.classList.remove('is-active');
                if (idx === currentSubstepIndex) ss.classList.add('is-active');
            });
        }
        // Hero text
        const substepKeys = getSubsteps(currentStep);
        const substepLabel = $3e790f855f3f746b$var$SUBSTEP_LABELS[currentStep]?.[substepKeys[currentSubstepIndex]] || '';
        const activeMeta = getActiveSubstepMeta();
        const isIntroScreen = activeMeta.key === 'intro';
        const isRecapScreen = activeMeta.key === 'recap';
        if (heroStep) heroStep.textContent = `Passaggio ${currentStep} di ${$3e790f855f3f746b$var$TOTAL_STEPS}`;
        if (heroContext) heroContext.textContent = $3e790f855f3f746b$var$STEP_NAMES[currentStep - 1] || '';
        if (stepLabel) stepLabel.textContent = `Passaggio ${currentStep} di ${$3e790f855f3f746b$var$TOTAL_STEPS}`;
        if (stepPercent) stepPercent.textContent = $3e790f855f3f746b$var$STEP_NAMES[currentStep - 1] || '';
        if (questionCard) questionCard.hidden = isIntroScreen;
        if (questionWhyBlock) questionWhyBlock.hidden = isIntroScreen || isRecapScreen;
        const stepPillar = $3e790f855f3f746b$var$STEP_PILLARS[currentStep];
        if (questionKicker) questionKicker.textContent = stepPillar ? `${$3e790f855f3f746b$var$STEP_NAMES[currentStep - 1]} \xb7 Pilastro ${stepPillar.pillar} di 4` : $3e790f855f3f746b$var$STEP_NAMES[currentStep - 1] || 'Planner';
        if (questionTitle) questionTitle.textContent = activeMeta.title;
        if (questionWhy) questionWhy.textContent = activeMeta.why;
        if (questionIcon) questionIcon.innerHTML = `<i class="ph ph-${activeMeta.icon}"></i>`;
        // Striscia dei 4 pilastri nell'hero
        const pillarStrip = document.getElementById('plannerPillarStrip');
        if (pillarStrip) pillarStrip.querySelectorAll('[data-pillar]').forEach((item)=>{
            item.classList.toggle('is-active', Boolean(stepPillar) && Number(item.dataset.pillar) === stepPillar.pillar);
        });
        // "La teoria in breve" per la schermata attiva
        const theoryBox = document.getElementById('plannerTheory');
        const theoryTitle = document.getElementById('plannerTheoryTitle');
        const theoryBody = document.getElementById('plannerTheoryBody');
        const theory = $3e790f855f3f746b$var$SUBSTEP_THEORY[activeMeta.key];
        if (theoryBox && theoryTitle && theoryBody) {
            if (theory && !isIntroScreen && !isRecapScreen) {
                theoryBox.hidden = false;
                theoryBox.open = true;
                theoryTitle.textContent = theory.title;
                const pillLinks = Array.isArray(theory.pills) && theory.pills.length ? `<p class="planner-theory-more">Approfondisci: ${theory.pills.map((pill)=>`<a href="${pill.href}" target="_blank" rel="noopener" data-track="internal:pills-course">${pill.label} \u2192</a>`).join(' \u00b7 ')}</p>` : '';
                theoryBody.innerHTML = theory.paragraphs.map((paragraph)=>`<p>${paragraph}</p>`).join('') + pillLinks;
            } else theoryBox.hidden = true;
        }
        const currentProgress = activeMeta.flowIndex + 1;
        const totalProgress = activeMeta.flowTotal || 1;
        const progressValue = Math.max(0, Math.min(100, Math.round(currentProgress / totalProgress * 100)));
        if (progressPercent) progressPercent.textContent = `${progressValue}%`;
        if (progressBar) progressBar.style.width = `${progressValue}%`;
        (0, $bCl3L.trackCheckupStep)(currentStep, activeMeta.key, progressValue);
        // Substep counter: si numerano solo le schermate con domande, così la prima
        // domanda è sempre "1 di N" (intro e riepilogo non contano, come i saltati)
        if (substepCounter) {
            const visibleKeys = substepKeys.filter((key)=>key !== 'intro' && key !== 'recap' && !isSubstepSkipped(currentStep, key));
            const total = visibleKeys.length;
            const position = visibleKeys.indexOf(substepKeys[currentSubstepIndex]) + 1;
            if (total > 1 && position > 0) substepCounter.textContent = `${position} di ${total} \xb7 ${substepLabel}`;
            else substepCounter.textContent = '';
        }
        // Button states
        const isFirstScreen = currentStep === 1 && currentSubstepIndex === 0;
        if (prevButton) prevButton.style.visibility = isFirstScreen || returnTarget ? 'hidden' : 'visible';
        // Button label: "Continua" on field screens, "Vedi risultati" on last step recap/intro
        const isLastStep = currentStep === $3e790f855f3f746b$var$TOTAL_STEPS;
        const isLastSubstep = currentSubstepIndex === substepKeys.length - 1;
        if (nextButton) {
            // Il testo vive in uno span dedicato, così la freccia Phosphor sopravvive ai cambi label
            const nextLabel = nextButton.querySelector('[data-nav-label]') || nextButton;
            if (returnTarget) nextLabel.textContent = 'Salva e torna al riepilogo';
            else if (isLastStep) nextLabel.textContent = 'Vedi risultati';
            else nextLabel.textContent = 'Avanti';
        }
        // Generate recap when entering recap substeps and on the final review screen
        if (substepKeys[currentSubstepIndex] === 'recap' || currentStep === 8) $3e790f855f3f746b$var$renderStepRecap(currentStep, jumpFromRecap);
        syncConditionalFields();
        // Schermate con una sola domanda: la domanda va nella label dell'input e il
        // titolo della card sparisce, così non si legge due volte la stessa cosa
        if (questionTitle && !isIntroScreen && !isRecapScreen) {
            const activeStepEl = steps.find((s)=>Number(s.dataset.step) === currentStep);
            const activeSubstepEl = activeStepEl?.querySelector('.planner-substep.is-active');
            const visibleFields = activeSubstepEl ? Array.from(activeSubstepEl.querySelectorAll('input:not([type="hidden"]), select, textarea')).filter((field)=>field.offsetParent !== null) : [];
            let soloLabel = visibleFields.length === 1 && visibleFields[0].id ? activeSubstepEl.querySelector(`label[for="${visibleFields[0].id}"]`) : null;
            if (soloLabel && soloLabel.children.length > 0) soloLabel = null;
            if (soloLabel) {
                if (soloLabel.dataset.originalLabel === undefined) soloLabel.dataset.originalLabel = soloLabel.textContent;
                soloLabel.textContent = activeMeta.title;
                questionTitle.hidden = true;
            } else {
                activeSubstepEl?.querySelectorAll('label[data-original-label]').forEach((label)=>{
                    label.textContent = label.dataset.originalLabel;
                    delete label.dataset.originalLabel;
                });
                questionTitle.hidden = false;
            }
        } else if (questionTitle) questionTitle.hidden = false;
        $3e790f855f3f746b$var$updateWizardPreview($3e790f855f3f746b$var$readWizardData(goalRows));
    };
    const displayError = (message)=>{
        if (!errorBox) return;
        if (!message) {
            errorBox.hidden = true;
            errorBox.textContent = '';
            return;
        }
        errorBox.hidden = false;
        errorBox.textContent = message;
    };
    const getCurrentData = ()=>$3e790f855f3f746b$var$readWizardData(goalRows);
    const setHiddenPrevious = (data)=>{
        const form = document.getElementById('financialPlannerForm');
        if (!form) return;
        [
            [
                'previousScore',
                data.previousScore
            ],
            [
                'previousDate',
                data.previousDate
            ]
        ].forEach(([id, value])=>{
            let field = document.getElementById(id);
            if (value === undefined || value === null || value === '') {
                field?.remove();
                return;
            }
            if (!field) {
                field = document.createElement('input');
                field.type = 'hidden';
                field.id = id;
                form.appendChild(field);
            }
            field.value = value;
        });
    };
    // Una bozza ha contenuto solo se differisce dal form vuoto: campi come
    // checkupDate o i select con default valorizzato non contano come risposte
    const serializeForDraft = (data)=>JSON.stringify({
            ...data,
            checkupDate: null
        });
    let pristineSnapshot = null; // impostato dopo la costruzione delle righe iniziali
    const draftHasContent = (data)=>pristineSnapshot !== null && serializeForDraft(data) !== pristineSnapshot;
    const persistState = ()=>{
        const data = getCurrentData();
        $3e790f855f3f746b$var$updateWizardPreview(data);
        if (draftHasContent(data)) (0, $a7oaJ.savePlannerDraft)(data, currentStep, currentSubstepIndex);
    };
    const applyEncodedState = ()=>{
        const encoded = new URLSearchParams(window.location.search).get('d');
        if (!encoded) return false;
        const decoded = (0, $bdDJG.decodeParams)(encoded);
        if (!decoded) return false;
        $3e790f855f3f746b$var$hydrateWizardForm(decoded, goalRows);
        syncConditionalFields();
        $3e790f855f3f746b$var$updateWizardPreview($3e790f855f3f746b$var$readWizardData(goalRows));
        return true;
    };
    accountRows?.appendChild($3e790f855f3f746b$var$createAccountRow());
    goalRows.appendChild($3e790f855f3f746b$var$createGoalRow());
    pristineSnapshot = serializeForDraft($3e790f855f3f746b$var$readWizardData(goalRows));
    addGoalButton?.addEventListener('click', ()=>{
        goalRows.appendChild($3e790f855f3f746b$var$createGoalRow());
    });
    addAccountButton?.addEventListener('click', ()=>{
        accountRows?.appendChild($3e790f855f3f746b$var$createAccountRow());
    });
    const depositRows = document.getElementById('depositRows');
    const addDepositButton = document.getElementById('addDepositButton');
    addDepositButton?.addEventListener('click', ()=>{
        depositRows?.appendChild($3e790f855f3f746b$var$createDepositRow());
    });
    // Aiuti di stima: in ogni pannello la somma delle categorie compila il campo
    // indicato da data-estimate-target
    document.querySelectorAll('.planner-estimate-helper').forEach((helper)=>{
        const target = document.getElementById(helper.dataset.estimateTarget || '');
        if (!target) return;
        const estimateFields = Array.from(helper.querySelectorAll('[data-estimate-field]'));
        estimateFields.forEach((field)=>{
            field.addEventListener('input', ()=>{
                const total = estimateFields.reduce((sum, item)=>sum + (0, $bdDJG.clampNumber)(item.value), 0);
                target.value = total > 0 ? total : '';
            });
        });
    });
    emergencyStatus?.addEventListener('change', syncConditionalFields);
    document.getElementById('familyStatus')?.addEventListener('change', syncConditionalFields);
    document.getElementById('hasBrokerAccount')?.addEventListener('change', syncConditionalFields);
    investmentsStatus?.addEventListener('change', syncConditionalFields);
    form.addEventListener('input', ()=>{
        (0, $bCl3L.trackCheckupStart)();
        persistState();
    });
    form.addEventListener('change', ()=>{
        (0, $bCl3L.trackCheckupStart)();
        persistState();
    });
    // Gli input numerici che valgono 0 si svuotano al focus, così si scrive subito
    // senza cancellare. Niente select(): su touch aprirebbe il menu copia/incolla.
    form.addEventListener('focusin', (event)=>{
        const target = event.target;
        if (target instanceof HTMLInputElement && target.type === 'number' && target.value === '0') {
            target.value = '';
            target.dataset.zeroCleared = '1';
        }
    });
    form.addEventListener('focusout', (event)=>{
        const target = event.target;
        if (target instanceof HTMLInputElement && target.dataset.zeroCleared) {
            delete target.dataset.zeroCleared;
            if (target.value === '') target.value = '0';
        }
    });
    // Tooltip dei campi: l'icona info mostra/nasconde la nota sotto il campo
    form.addEventListener('click', (event)=>{
        const toggle = event.target.closest('[data-info-toggle]');
        if (!toggle) return;
        event.preventDefault();
        const note = toggle.closest('.input-group')?.querySelector('[data-info-note]');
        if (!note) return;
        const wasHidden = note.hidden;
        note.hidden = !wasHidden;
        toggle.setAttribute('aria-expanded', String(wasHidden));
    });
    form.addEventListener('keydown', (event)=>{
        if (event.key !== 'Enter' || event.shiftKey || event.isComposing) return;
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;
        if (!target.closest('.planner-substep.is-active')) return;
        if (!target.matches('input, select')) return;
        event.preventDefault();
        nextButton?.click();
    });
    prevButton?.addEventListener('click', ()=>{
        displayError(null);
        if (currentSubstepIndex > 0) {
            currentSubstepIndex -= 1;
            while(currentSubstepIndex > 0 && isSubstepSkipped(currentStep, getSubsteps(currentStep)[currentSubstepIndex]))currentSubstepIndex -= 1;
        } else if (currentStep > 1) {
            currentStep -= 1;
            const prevSubsteps = getSubsteps(currentStep);
            currentSubstepIndex = prevSubsteps.length - 1;
        }
        updateStepUi();
        persistState();
        scrollToPanelTop();
    });
    nextButton?.addEventListener('click', ()=>{
        const substepKeys = getSubsteps(currentStep);
        const activeSubstepKey = substepKeys[currentSubstepIndex];
        // If on recap, advance to next step's intro
        if (activeSubstepKey === 'recap') {
            if (currentStep < $3e790f855f3f746b$var$TOTAL_STEPS) {
                currentStep += 1;
                currentSubstepIndex = 0;
                displayError(null);
                updateStepUi();
                persistState();
                scrollToPanelTop();
                return;
            }
            // Last step: submit
            const data = getCurrentData();
            const encoded = (0, $bdDJG.encodeParams)(data);
            if (!encoded) {
                displayError('Impossibile preparare i risultati. Riprova.');
                return;
            }
            window.location.href = `/check-up-finanziario/risultati?d=${encodeURIComponent(encoded)}`;
            return;
        }
        if (activeSubstepKey !== 'intro') {
            const data = getCurrentData();
            const substepError = $3e790f855f3f746b$var$validateSubstep(currentStep, activeSubstepKey, data);
            if (substepError) {
                displayError(substepError);
                return;
            }
        }
        // Modifica puntuale da un riepilogo: salvata la risposta, si torna lì
        if (returnTarget) {
            const target = returnTarget;
            returnTarget = null;
            displayError(null);
            setSubstep(target.step, target.substepIndex);
            persistState();
            return;
        }
        // If on last step (8), go directly to results
        if (currentStep === $3e790f855f3f746b$var$TOTAL_STEPS) {
            const data = getCurrentData();
            const encoded = (0, $bdDJG.encodeParams)(data);
            if (!encoded) {
                displayError('Impossibile preparare i risultati. Riprova.');
                return;
            }
            window.location.href = `/check-up-finanziario/risultati?d=${encodeURIComponent(encoded)}`;
            return;
        }
        // Advance to next substep
        if (currentSubstepIndex < substepKeys.length - 1) {
            currentSubstepIndex += 1;
            while(currentSubstepIndex < substepKeys.length - 1 && isSubstepSkipped(currentStep, substepKeys[currentSubstepIndex]))currentSubstepIndex += 1;
            // If we just landed on recap, render it
            if (substepKeys[currentSubstepIndex] === 'recap') {
                const data = getCurrentData();
                const validationError = $3e790f855f3f746b$var$validateStep(currentStep, data);
                if (validationError) {
                    currentSubstepIndex -= 1;
                    displayError(validationError);
                    return;
                }
            }
            displayError(null);
            updateStepUi();
            persistState();
            scrollToPanelTop();
            return;
        }
        // This shouldn't normally happen (recap handles next step)
        currentStep += 1;
        currentSubstepIndex = 0;
        displayError(null);
        updateStepUi();
        persistState();
        scrollToPanelTop();
    });
    const hydratedFromQuery = applyEncodedState();
    // Ripristina la bozza salvata su questo dispositivo (l'URL condiviso ha precedenza)
    let restoredFromDraft = false;
    if (!hydratedFromQuery) {
        const draft = (0, $a7oaJ.loadPlannerDraft)();
        if (draft?.data && draftHasContent(draft.data)) {
            restoredFromDraft = true;
            $3e790f855f3f746b$var$hydrateWizardForm(draft.data, goalRows);
            setHiddenPrevious(draft.data);
            if (Number.isInteger(draft.step) && $3e790f855f3f746b$var$SUBSTEP_CONFIG[draft.step]) {
                currentStep = draft.step;
                const draftSubsteps = getSubsteps(currentStep);
                currentSubstepIndex = Math.min(Math.max((0, $bdDJG.clampNumber)(draft.substepIndex), 0), draftSubsteps.length - 1);
            }
            const resumeNotice = document.getElementById('plannerResumeNotice');
            if (resumeNotice) resumeNotice.hidden = false;
            (0, $bCl3L.trackCheckupResume)(currentStep);
        }
    }
    const resetButton = document.getElementById('plannerResetButton');
    resetButton?.addEventListener('click', ()=>{
        (0, $a7oaJ.clearPlannerDraft)();
        window.location.href = '/check-up-finanziario/wizard';
    });
    // Import di un backup: ripopola le risposte e riparte dall'ultima schermata
    const backupInput = document.getElementById('backupInput');
    backupInput?.addEventListener('change', async (event)=>{
        const file = event.target.files?.[0];
        event.target.value = ''; // permette di ricaricare lo stesso file
        if (!file) return;
        try {
            const backup = await (0, $ctPgg.readBackupFile)(file);
            const restored = {
                ...backup.data
            };
            if (backup.score?.total !== undefined && backup.score?.total !== null) {
                restored.previousScore = backup.score.total;
                restored.previousDate = backup.savedAt || null;
            }
            $3e790f855f3f746b$var$hydrateWizardForm(restored, goalRows);
            setHiddenPrevious(restored);
            syncConditionalFields();
            displayError(null);
            (0, $bCl3L.trackCheckupAction)('backup_import');
            const notice = document.getElementById('plannerResumeNotice');
            if (notice) {
                const savedLabel = (0, $ctPgg.formatBackupDate)(backup.savedAt);
                const scoreLabel = backup.score?.total !== undefined && backup.score?.total !== null ? ` Il voto di allora era ${backup.score.total}/100: rifallo e vedi se \xe8 salito.` : '';
                notice.querySelector('span').textContent = `Backup caricato${savedLabel ? ` (check-up del ${savedLabel})` : ''}: abbiamo ripristinato le tue risposte.${scoreLabel}`;
                notice.hidden = false;
            }
            currentStep = $3e790f855f3f746b$var$TOTAL_STEPS;
            currentSubstepIndex = 0;
            updateStepUi();
            persistState();
            scrollToPanelTop();
        } catch (error) {
            displayError(error.message || "Non \xe8 stato possibile caricare il backup.");
        }
    });
    if (currentStep === 1 && currentSubstepIndex === 0) currentSubstepIndex = 0;
    // Modalità modifica (dai risultati): si atterra sul riepilogo finale,
    // da lì si sceglie cosa cambiare e si torna ai risultati con "Vedi risultati"
    if (editRequested && (hydratedFromQuery || restoredFromDraft)) {
        currentStep = $3e790f855f3f746b$var$TOTAL_STEPS;
        currentSubstepIndex = 0;
    }
    syncConditionalFields();
    updateStepUi();
    if (hydratedFromQuery) $3e790f855f3f746b$var$updateWizardPreview($3e790f855f3f746b$var$readWizardData(goalRows));
    else persistState();
}
document.addEventListener('DOMContentLoaded', $3e790f855f3f746b$var$initWizard);


//# sourceMappingURL=wizard.c750daf8.js.map
